/* KC Apparel Engine v0.1 — Koval Customs, nadruki z podgladem na zywo (koszulka / bluza / kaptur).
 * Jeden kod rysuje WZOR (przezroczyste tlo, plik do druku 300 DPI) i sklada go na ubraniu w wybranym kolorze (podglad).
 * Szablon: { w, h (cm wzoru), fonts, draw(ctx, W, H, d) }. d = dane z kc-options (zdjecia, teksty, kolory) + d.ink / d.dark.
 * Pomocnicze funkcje tekstu/zdjec przeniesione z kc-poster-engine.js (plakaty), zeby oba silniki dzialaly niezaleznie.
 */
(function (global) {
  'use strict';

  var DPI = 300, CM = DPI / 2.54;

  // ---------- kolory ubran (wartosci kc-options: "Czarna - Black" itd.; dopasowanie po polskim slowie) ----------
  var COLORS = {
    czarna: '#1C1C1E', szara: '#BDBDB9', biala: '#F6F5F1', granatowa: '#1F2A44', rozowa: '#F2BCC9',
    niebieska: '#2B4EA2', blekitna: '#A9C9E8', czerwona: '#B2222C', grafitowa: '#48484C', bezowa: '#D8C7AA',
    bordowa: '#6A1E2B', zielona: '#2E4A37', brazowa: '#5A4033', military: '#5B5E45'
  };
  function plain(s) {
    return String(s || '').toLowerCase().replace(/[ąćęłńóśźż]/g, function (c) { return 'acelnoszz'['ąćęłńóśźż'.indexOf(c)]; });
  }
  function colorHex(val) {
    var w = plain(val).split(/[\s-]/)[0];
    if (COLORS[w]) return COLORS[w];
    var keys = Object.keys(COLORS);
    for (var i = 0; i < keys.length; i++) if (plain(val).indexOf(keys[i]) >= 0) return COLORS[keys[i]];
    return COLORS.biala;
  }
  function lum(hex) {
    var n = parseInt(hex.slice(1), 16), r = n >> 16, g = (n >> 8) & 255, b = n & 255;
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  }
  function isDark(hex) { return lum(hex) < 0.5; }

  // ---------- tekst ----------
  function font(weight, px, family, italic) { return (italic ? 'italic ' : '') + weight + ' ' + Math.max(1, Math.round(px)) + 'px "' + family + '"'; }
  function textW(ctx, text, tr) {
    var px = parseFloat(ctx.font.match(/(\d+)px/)[1]), chars = Array.from(String(text || '')), t = 0;
    for (var i = 0; i < chars.length; i++) t += ctx.measureText(chars[i]).width;
    return t + px * (tr || 0) * Math.max(0, chars.length - 1);
  }
  function fit(ctx, text, weight, px, family, maxW, tr, italic) {
    var size = px;
    for (var i = 0; i < 60; i++) {
      ctx.font = font(weight, size, family, italic);
      if (textW(ctx, text, tr) <= maxW) break;
      size *= 0.95;
    }
    ctx.font = font(weight, size, family, italic);
    return size;
  }
  // tekst z odstepem liter; align left/center/right; mode fill/stroke/both
  function textAt(ctx, text, x, y, tr, align, mode) {
    text = String(text || '');
    var px = parseFloat(ctx.font.match(/(\d+)px/)[1]), gap = px * (tr || 0), chars = Array.from(text), ws = [], total = 0;
    for (var i = 0; i < chars.length; i++) { ws[i] = ctx.measureText(chars[i]).width; total += ws[i]; }
    total += gap * Math.max(0, chars.length - 1);
    var sx = align === 'right' ? x - total : (align === 'center' ? x - total / 2 : x);
    ctx.textAlign = 'left';
    for (var j = 0; j < chars.length; j++) {
      if (mode !== 'stroke') ctx.fillText(chars[j], sx, y);
      if (mode === 'stroke' || mode === 'both') ctx.strokeText(chars[j], sx, y);
      sx += ws[j] + gap;
    }
    return total;
  }
  function hexA(hex, a) { var n = parseInt(hex.slice(1), 16); return 'rgba(' + (n >> 16) + ',' + ((n >> 8) & 255) + ',' + (n & 255) + ',' + a + ')'; }

  // ---------- v2 (A-plakaty 09.10): ton zdjec + kolor ramek polaroidow, ustawiane przez klienta dla calego wzoru ----------
  // d.tone: 'kolor' | 'czb' | 'vintage' (brak = domyslny filtr wzoru); d.frame: 'vintage' | 'bialy' | 'czarny'
  var TONE = null, FRAME = 'vintage';
  var TONE_F = { kolor: null, czb: 'grayscale(1) contrast(1.08)', vintage: 'grayscale(1) sepia(0.45) contrast(1.06) brightness(0.96)' };
  var CAN_FILTER = (function () { try { var cv = document.createElement('canvas'); cv.width = cv.height = 2; var c = cv.getContext('2d'); c.filter = 'grayscale(1)'; if (c.filter !== 'grayscale(1)') return false; c.fillStyle = '#ff0000'; c.fillRect(0, 0, 2, 2); var d = c.getImageData(0, 0, 1, 1).data; return Math.abs(d[0] - d[1]) < 40; } catch (e) { return false; } })();
  function pixTone(c, w, h, f) { // zastepstwo ctx.filter (starsze Safari): cz-b / sepia na pikselach
    var id; try { id = c.getImageData(0, 0, w, h); } catch (e) { return; }
    var p = id.data, sep = /sepia/.test(f), br = /brightness\(0\.96\)/.test(f) ? 0.96 : 1;
    for (var i = 0; i < p.length; i += 4) {
      var l = 0.299 * p[i] + 0.587 * p[i + 1] + 0.114 * p[i + 2]; l = Math.min(255, Math.max(0, ((l - 128) * 1.07 + 128) * br));
      if (sep) { p[i] = Math.min(255, l * 1.08 + 10); p[i + 1] = Math.min(255, l * 0.98 + 4); p[i + 2] = l * 0.84; } else p[i] = p[i + 1] = p[i + 2] = l;
    }
    c.putImageData(id, 0, 0);
  }
  // ---------- zdjecia ----------
  // ph = { img, cut?, zoom?, ox?, oy? } ; cover w prostokacie
  function drawPhoto(ctx, ph, x, y, w, h, filter) {
    var img = ph.img, z = ph.zoom || 1, iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
    ph._ar = w / h; // proporcje pola w szablonie -> edytor kadru (klient przesuwa zdjecie w polu)
    var sc = Math.max(w / iw, h / ih) * z, dw = iw * sc, dh = ih * sc;
    var dx = x + (w - dw) / 2 - (ph.ox || 0) * (dw - w) / 2, dy = y + (h - dh) / 2 - (ph.oy || 0) * (dh - h) / 2;
    if (TONE) filter = TONE_F[TONE];
    ctx.save(); ctx.beginPath(); ctx.rect(x, y, w, h); ctx.clip();
    if (!filter) ctx.drawImage(img, dx, dy, dw, dh);
    else { // filtr na osobnym canvasie: dziala tez przy obrotach i bez ctx.filter
      var tw = Math.max(1, Math.ceil(w)), th = Math.max(1, Math.ceil(h)), t = document.createElement('canvas'); t.width = tw; t.height = th;
      var tx = t.getContext('2d'); if (CAN_FILTER) tx.filter = filter;
      tx.drawImage(img, (dx - x) * tw / w, (dy - y) * th / h, dw * tw / w, dh * th / h);
      if (!CAN_FILTER) pixTone(tx, tw, th, filter);
      ctx.drawImage(t, x, y, w, h);
    }
    if (TONE === 'vintage') { var ag = img_(TEX_BASE + 'polaroid-age.png'); if (ready(ag)) { ctx.globalAlpha = 0.85; ctx.drawImage(ag, x, y, w, h); } }
    ctx.restore();
    return sc;
  }
  function slot(ctx, x, y, w, h, n, ink) { // pusty slot na zdjecie
    ctx.save(); ctx.fillStyle = hexA(ink, 0.10); ctx.fillRect(x, y, w, h);
    ctx.strokeStyle = hexA(ink, 0.35); ctx.setLineDash([w * 0.04, w * 0.03]); ctx.lineWidth = Math.max(1, w * 0.008); ctx.strokeRect(x, y, w, h);
    ctx.setLineDash([]); ctx.fillStyle = hexA(ink, 0.55); ctx.font = font(600, Math.min(w, h) * 0.13, 'Hanken Grotesk');
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText(n ? 'Zdjęcie ' + n : 'Zdjęcie', x + w / 2, y + h / 2);
    ctx.textBaseline = 'alphabetic'; ctx.restore();
  }
  function photoOr(ctx, ph, x, y, w, h, n, ink, filter) {
    if (ph && ph.img) return drawPhoto(ctx, ph, x, y, w, h, filter);
    slot(ctx, x, y, w, h, n, ink); return 0;
  }
  // jakosc: px zrodla na cm druku (300 DPI = 118 px/cm); < 40 px/cm = slabo
  function pxPerCm(ph, wCm, hCm) {
    if (!ph || !ph.img) return null;
    var iw = ph.img.naturalWidth || ph.img.width, ih = ph.img.naturalHeight || ph.img.height;
    return Math.min(iw / wCm, ih / hCm) / (ph.zoom || 1);
  }

  // Tlo kartki -> przezroczyste (rysunek dziecka), v2 (user 09.10: "niektorzy wstawiaja rysunek na kartce"):
  // 1) stol/podloga wokol kartki: zalewanie od krawedzi zdjecia po pikselach NIE-kartki -> usuniete;
  // 2) nierowne swiatlo/cien na kartce: lokalny kolor kartki z siatki blokow (jasny percentyl + uzupelnianie z sasiadow);
  // 3) alfa = o ile piksel jest ciemniejszy od kartki w najciemniejszym kanale; kolor = wyrownany do bialej kartki (czyste kredki).
  // strength: 0.6 delikatnie (zostawia slabe kreski olowkiem), 1 normalnie, 1.5 mocno (usuwa tez cienie/brud).
  function paperToAlpha(img, strength) {
    if (!img) return null;
    var st = strength || 1, key = '_kcPaper2_' + st;
    if (img[key]) return img[key];
    var w0 = img.naturalWidth || img.width, h0 = img.naturalHeight || img.height, s = Math.min(1, 1600 / Math.max(w0, h0));
    var w = Math.round(w0 * s), h = Math.round(h0 * s), N = w * h;
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d'); x.drawImage(img, 0, 0, w, h);
    var id; try { id = x.getImageData(0, 0, w, h); } catch (e) { return img; }
    var p = id.data, L = new Float32Array(N), C = new Float32Array(N), i, k;
    for (i = 0; i < N; i++) { k = i * 4; var r = p[k], g = p[k + 1], b = p[k + 2], mx = Math.max(r, g, b), mn = Math.min(r, g, b); L[i] = mx; C[i] = mx - mn; }
    // jasnosc kartki globalnie = 85. percentyl jasnych, malo nasyconych pikseli
    var hist = new Uint32Array(256), cnt = 0;
    for (i = 0; i < N; i += 3) if (C[i] < 45) { hist[L[i] | 0]++; cnt++; }
    var acc = 0, PL = 230; for (i = 255; i >= 0; i--) { acc += hist[i]; if (acc > cnt * 0.15) { PL = i; break; } }
    // 1) kartka = najwiekszy spojny obszar jasnych, malo nasyconych pikseli; jej wypukla otoczka = cala kartka
    //    (z rysunkiem i cieniem w srodku). Wszystko poza otoczka (stol, podloga) -> przezroczyste.
    var paperish = new Uint8Array(N), out = new Uint8Array(N), lab = new Uint8Array(N), q = new Int32Array(N);
    for (i = 0; i < N; i++) paperish[i] = (L[i] > PL * 0.72 && C[i] < 52 && C[i] < L[i] * 0.26) ? 1 : 0; // drewno/stol ma C/L ~0.5+
    var best = null, bestN = 0;
    for (var s0 = 0; s0 < N; s0 += 7) {
      if (!paperish[s0] || lab[s0]) continue;
      var qh = 0, qt = 0, n0 = 0, rmin = new Int32Array(h).fill(w), rmax = new Int32Array(h).fill(-1);
      lab[s0] = 1; q[qt++] = s0;
      while (qh < qt) {
        var j = q[qh++], jx = j % w, jy = (j / w) | 0; n0++;
        if (jx < rmin[jy]) rmin[jy] = jx; if (jx > rmax[jy]) rmax[jy] = jx;
        if (jx > 0 && paperish[j - 1] && !lab[j - 1]) { lab[j - 1] = 1; q[qt++] = j - 1; }
        if (jx < w - 1 && paperish[j + 1] && !lab[j + 1]) { lab[j + 1] = 1; q[qt++] = j + 1; }
        if (jy > 0 && paperish[j - w] && !lab[j - w]) { lab[j - w] = 1; q[qt++] = j - w; }
        if (jy < h - 1 && paperish[j + w] && !lab[j + w]) { lab[j + w] = 1; q[qt++] = j + w; }
      }
      if (n0 > bestN) { bestN = n0; best = { rmin: rmin, rmax: rmax }; }
    }
    if (best && bestN > N * 0.12) {
      var pts = [];
      for (var yy0 = 0; yy0 < h; yy0++) if (best.rmax[yy0] >= 0) { pts.push([best.rmin[yy0], yy0]); pts.push([best.rmax[yy0], yy0]); }
      pts.sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; });
      function cr(o, a, b) { return (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0]); }
      var lo = [], up = [];
      pts.forEach(function (pt) { while (lo.length > 1 && cr(lo[lo.length - 2], lo[lo.length - 1], pt) <= 0) lo.pop(); lo.push(pt); });
      for (var pi = pts.length - 1; pi >= 0; pi--) { var pt = pts[pi]; while (up.length > 1 && cr(up[up.length - 2], up[up.length - 1], pt) <= 0) up.pop(); up.push(pt); }
      var hull = lo.slice(0, -1).concat(up.slice(0, -1));
      var mc = document.createElement('canvas'); mc.width = w; mc.height = h; var mx2 = mc.getContext('2d');
      mx2.fillStyle = '#fff'; mx2.beginPath(); hull.forEach(function (pt, ii) { if (ii) mx2.lineTo(pt[0] + 0.5, pt[1] + 0.5); else mx2.moveTo(pt[0] + 0.5, pt[1] + 0.5); }); mx2.closePath(); mx2.fill();
      // brzeg kartki (krawedz, cien kartki na stole) - zjedz ~1% obrazu do srodka
      mx2.globalCompositeOperation = 'destination-out'; mx2.lineWidth = Math.max(6, Math.round(Math.max(w, h) * 0.012)); mx2.lineJoin = 'round'; mx2.stroke();
      var md2 = mx2.getImageData(0, 0, w, h).data, inside = 0;
      for (i = 0; i < N; i++) { out[i] = md2[i * 4 + 3] < 128 ? 1 : 0; inside += 1 - out[i]; }
      if (inside > N * 0.97) out.fill(0); // kartka wypelnia kadr - nic nie wycinamy
    }
    // 2) lokalny kolor kartki: siatka blokow, w bloku srednia z najjasniejszych kartko-podobnych pikseli
    var B = Math.max(16, Math.round(Math.max(w, h) / 64)), gw = Math.ceil(w / B), gh = Math.ceil(h / B), G = gw * gh;
    var gr = new Float32Array(G), gg = new Float32Array(G), gb = new Float32Array(G), ok = new Uint8Array(G);
    for (var by = 0; by < gh; by++) for (var bx = 0; bx < gw; bx++) {
      var vals = [];
      for (var yy = by * B; yy < Math.min(h, by * B + B); yy += 2) for (var xx = bx * B; xx < Math.min(w, bx * B + B); xx += 2) { var t = yy * w + xx; if (!out[t] && C[t] < 52 && C[t] < L[t] * 0.3) vals.push(t); }
      if (vals.length < B * B / 4 * 0.25) continue;
      vals.sort(function (m, n) { return L[n] - L[m]; });
      var top = vals.slice(0, Math.max(1, vals.length >> 2)), sr = 0, sg = 0, sb = 0;
      top.forEach(function (t) { sr += p[t * 4]; sg += p[t * 4 + 1]; sb += p[t * 4 + 2]; });
      var gi = by * gw + bx; gr[gi] = sr / top.length; gg[gi] = sg / top.length; gb[gi] = sb / top.length; ok[gi] = 1;
    }
    // bloki bez kartki (duze zamalowane pola) -> srednia z sasiadow, az wszystko wypelnione
    var any = false; for (i = 0; i < G; i++) if (ok[i]) { any = true; break; }
    if (!any) for (i = 0; i < G; i++) { gr[i] = gg[i] = gb[i] = PL; ok[i] = 1; }
    for (var pass = 0; pass < gw + gh; pass++) {
      var miss = 0, nk = ok.slice();
      for (i = 0; i < G; i++) if (!ok[i]) {
        var ix = i % gw, iy = (i / gw) | 0, n = 0, ar = 0, ag = 0, ab = 0;
        [[-1, 0], [1, 0], [0, -1], [0, 1], [-1, -1], [1, 1], [-1, 1], [1, -1]].forEach(function (d) {
          var X = ix + d[0], Y = iy + d[1]; if (X < 0 || Y < 0 || X >= gw || Y >= gh) return; var o = Y * gw + X; if (!ok[o]) return; n++; ar += gr[o]; ag += gg[o]; ab += gb[o];
        });
        if (n) { gr[i] = ar / n; gg[i] = ag / n; gb[i] = ab / n; nk[i] = 1; } else miss++;
      }
      ok = nk; if (!miss) break;
    }
    // wygladzenie siatki 3x3
    function blur(a) { var o = new Float32Array(G); for (var Y = 0; Y < gh; Y++) for (var X = 0; X < gw; X++) { var su = 0, nn = 0; for (var dy = -1; dy <= 1; dy++) for (var dx = -1; dx <= 1; dx++) { var X2 = X + dx, Y2 = Y + dy; if (X2 < 0 || Y2 < 0 || X2 >= gw || Y2 >= gh) continue; su += a[Y2 * gw + X2]; nn++; } o[Y * gw + X] = su / nn; } return o; }
    gr = blur(gr); gg = blur(gg); gb = blur(gb);
    // lokalne maksimum jasnosci (promien ~0.4% obrazu): miekka krawedz cienia nie jest kreska
    var R6 = Math.max(4, Math.round(Math.max(w, h) * 0.004)), M1 = new Float32Array(N), LM = new Float32Array(N);
    for (var yA = 0; yA < h; yA++) for (var xA = 0; xA < w; xA++) { var m1 = 0; for (var dA = -R6; dA <= R6; dA++) { var xx2 = xA + dA; if (xx2 >= 0 && xx2 < w && L[yA * w + xx2] > m1) m1 = L[yA * w + xx2]; } M1[yA * w + xA] = m1; }
    for (yA = 0; yA < h; yA++) for (xA = 0; xA < w; xA++) { var m2 = 0; for (dA = -R6; dA <= R6; dA++) { var yy2 = yA + dA; if (yy2 >= 0 && yy2 < h && M1[yy2 * w + xA] > m2) m2 = M1[yy2 * w + xA]; } LM[yA * w + xA] = m2; }
    // 3) alfa + kolor wyrownany do bieli (interpolacja dwuliniowa siatki)
    var t0 = 0.10 * st, t1 = 0.10 * st + 0.16;
    for (var y = 0; y < h; y++) {
      var fy = Math.min(gh - 1, Math.max(0, (y + 0.5) / B - 0.5)), y0 = fy | 0, y1 = Math.min(gh - 1, y0 + 1), vy = fy - y0;
      for (var x0p = 0; x0p < w; x0p++) {
        i = y * w + x0p; k = i * 4;
        if (out[i]) { p[k + 3] = 0; continue; }
        var fx = Math.min(gw - 1, Math.max(0, (x0p + 0.5) / B - 0.5)), x0 = fx | 0, x1 = Math.min(gw - 1, x0 + 1), vx = fx - x0;
        var a00 = y0 * gw + x0, a01 = y0 * gw + x1, a10 = y1 * gw + x0, a11 = y1 * gw + x1;
        var Rb = (gr[a00] * (1 - vx) + gr[a01] * vx) * (1 - vy) + (gr[a10] * (1 - vx) + gr[a11] * vx) * vy;
        var Gb = (gg[a00] * (1 - vx) + gg[a01] * vx) * (1 - vy) + (gg[a10] * (1 - vx) + gg[a11] * vx) * vy;
        var Bb = (gb[a00] * (1 - vx) + gb[a01] * vx) * (1 - vy) + (gb[a10] * (1 - vx) + gb[a11] * vx) * vy;
        var rr = Math.min(1, p[k] / Math.max(1, Rb)), rg = Math.min(1, p[k + 1] / Math.max(1, Gb)), rb = Math.min(1, p[k + 2] / Math.max(1, Bb));
        var sat = Math.max(rr, rg, rb) - Math.min(rr, rg, rb), gp = sat < 0.12 ? 0.09 * st * (1 - sat / 0.12) : 0;
        var dark = 1 - Math.min(rr, rg, rb);
        if (sat < 0.12 && dark < 0.55) dark = Math.min(dark, 1 - L[i] / Math.max(1, LM[i]) + 0.04); // szare: musi byc ciemniejsze od okolicy (kreska), nie tylko od kartki (cien)
        var a = dark <= t0 + gp ? 0 : (dark >= t1 + gp ? 1 : (dark - t0 - gp) / (t1 - t0));
        a = a * a * (3 - 2 * a);
        if (a <= 0) { p[k + 3] = 0; continue; }
        // kolor tuszu: c = 1 - (1 - r) / a (odjecie kartki z polprzezroczystego brzegu)
        var ia = 1 / Math.max(a, 0.35);
        p[k] = Math.max(0, Math.min(255, 255 * (1 - (1 - rr) * ia)));
        p[k + 1] = Math.max(0, Math.min(255, 255 * (1 - (1 - rg) * ia)));
        p[k + 2] = Math.max(0, Math.min(255, 255 * (1 - (1 - rb) * ia)));
        p[k + 3] = Math.round(a * 255);
      }
    }
    // drobny brud: pojedyncze piksele bez sasiadow -> usun
    for (y = 1; y < h - 1; y++) for (var xq = 1; xq < w - 1; xq++) {
      i = y * w + xq; if (p[i * 4 + 3] < 8) continue;
      var nb = (p[(i - 1) * 4 + 3] > 40) + (p[(i + 1) * 4 + 3] > 40) + (p[(i - w) * 4 + 3] > 40) + (p[(i + w) * 4 + 3] > 40);
      if (nb === 0) p[i * 4 + 3] = 0;
    }
    x.putImageData(id, 0, 0);
    var bb = alphaBox(p, w, h), res = c;
    if (bb) { res = document.createElement('canvas'); res.width = bb.w; res.height = bb.h; res.getContext('2d').drawImage(c, bb.x, bb.y, bb.w, bb.h, 0, 0, bb.w, bb.h); }
    res.naturalWidth = res.width; res.naturalHeight = res.height;
    img[key] = res;
    return res;
  }
  function alphaBox(p, w, h) {
    var x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) if (p[(y * w + x) * 4 + 3] > 24) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    if (x1 < 0) return null;
    var m = 4; x0 = Math.max(0, x0 - m); y0 = Math.max(0, y0 - m); x1 = Math.min(w - 1, x1 + m); y1 = Math.min(h - 1, y1 + m);
    return { x: x0, y: y0, w: x1 - x0 + 1, h: y1 - y0 + 1 };
  }
  function drawContain(ctx, src, x, y, w, h, alignY) {
    var iw = src.naturalWidth || src.width, ih = src.naturalHeight || src.height, sc = Math.min(w / iw, h / ih);
    var dw = iw * sc, dh = ih * sc, dy = alignY === 'bottom' ? y + h - dh : (alignY === 'top' ? y : y + (h - dh) / 2);
    ctx.drawImage(src, x + (w - dw) / 2, dy, dw, dh);
    return { x: x + (w - dw) / 2, y: dy, w: dw, h: dh, sc: sc };
  }

  function barcode(ctx, x, y, w, h, seed, ink) {
    var n = 0; seed = String(seed || 'KOVAL'); for (var i = 0; i < seed.length; i++) n = (n * 31 + seed.charCodeAt(i)) >>> 0;
    ctx.save(); ctx.fillStyle = ink; var bx = x;
    while (bx < x + w) {
      n = (n * 1103515245 + 12345) >>> 0;
      var bw = w * (0.008 + (n % 4) * 0.008);
      if ((n >> 3) % 3) ctx.fillRect(bx, y, Math.min(bw, x + w - bx), h);
      bx += bw + w * 0.011;
    }
    ctx.restore();
  }
  function heart(ctx, cx, cy, s, color) {
    ctx.save(); ctx.fillStyle = color; ctx.beginPath();
    ctx.moveTo(cx, cy + s * 0.35);
    ctx.bezierCurveTo(cx - s * 0.9, cy - s * 0.25, cx - s * 0.35, cy - s * 0.95, cx, cy - s * 0.4);
    ctx.bezierCurveTo(cx + s * 0.35, cy - s * 0.95, cx + s * 0.9, cy - s * 0.25, cx, cy + s * 0.35);
    ctx.fill(); ctx.restore();
  }
  // "EST. 2020" -> rok; dowolny tekst zostaje
  function yearOf(s) { var m = String(s || '').match(/(19|20)\d\d/); return m ? m[0] : String(s || '').trim(); }

  // ================= SZABLONY =================
  // ---------- GREENSCREEN (user 09.10): gotowe pliki wzorow, zielone pola = zdjecia klienta ----------
  // Zasoby z greenscreen/_gs_build.py -> gs/<id>/{dark|light}.png (wzor), -s<N>.png (maski pol), meta w window.KCApparelGS.
  // dark = bialy wzor na ciemne ubrania, light = czarny na jasne; brak wariantu -> drugi przekolorowany na d.ink.
  var GS_BASE = 'gs/';
  function gsDraw(tpl, ctx, W, H, d, filter, aged) { // tpl = {id, w, h}; aged = rysy/kurz/winieta na zdjeciach
    var meta = (global.KCApparelGS || {})[tpl.id]; if (!meta) return null;
    var v = d.dark ? 'dark' : 'light', recolor = false;
    if (!meta[v]) { v = meta.dark ? 'dark' : 'light'; recolor = true; }
    var m = meta[v], base = GS_BASE + tpl.id + '/' + v, inkI = img(base + '.png');
    var s = Math.min(W / m.W, H / m.H), ox = (W - m.W * s) / 2, oy = (H - m.H * s) / 2, ph = d.photos || [];
    d._q = [];
    m.slots.forEach(function (sl, i) {
      var mk = img(base + '-s' + (i + 1) + '.png'), x = ox + sl.x * s, y = oy + sl.y * s, w = sl.w * s, h = sl.h * s;
      var c = document.createElement('canvas'); c.width = Math.max(1, Math.ceil(w)); c.height = Math.max(1, Math.ceil(h));
      var cx = c.getContext('2d');
      if (ph[i] && ph[i].img) {
        drawPhoto(cx, ph[i], 0, 0, c.width, c.height, filter);
        var ag = aged && !TONE && img(TEX_BASE + 'polaroid-age.png'); if (ag && ready(ag)) cx.drawImage(ag, 0, 0, c.width, c.height);
        d._q.push({ ph: ph[i], wCm: w / W * tpl.w, hCm: h / H * tpl.h });
      } else { // puste pole: lekki odcien wzoru + "Zdjecie N"
        cx.fillStyle = hexA(d.ink, 0.16); cx.fillRect(0, 0, c.width, c.height);
        cx.fillStyle = hexA(d.ink, 0.6); cx.font = font(600, Math.min(c.width, c.height) * 0.12, 'Hanken Grotesk');
        cx.textAlign = 'center'; cx.textBaseline = 'middle'; cx.fillText('Zdjęcie ' + (i + 1), c.width / 2, c.height / 2);
      }
      if (!ready(mk)) return;
      cx.globalCompositeOperation = 'destination-in'; cx.drawImage(mk, 0, 0, c.width, c.height);
      ctx.drawImage(c, x, y, w, h);
    });
    var cardM = FRAME !== 'vintage' && img(base + '-card.png');
    if (ready(inkI) && cardM && ready(cardM)) {
      var rc = document.createElement('canvas'); rc.width = Math.ceil(m.W * s); rc.height = Math.ceil(m.H * s);
      var rcx = rc.getContext('2d'); rcx.drawImage(inkI, 0, 0, rc.width, rc.height);
      var mc = document.createElement('canvas'); mc.width = rc.width; mc.height = rc.height; mc.getContext('2d').drawImage(cardM, 0, 0, rc.width, rc.height);
      try {
        var px = rcx.getImageData(0, 0, rc.width, rc.height), mp = mc.getContext('2d').getImageData(0, 0, rc.width, rc.height).data, q = px.data;
        for (var o = 0; o < q.length; o += 4) {
          if (mp[o] < 128 || q[o + 3] === 0) continue;
          var L = 0.299 * q[o] + 0.587 * q[o + 1] + 0.114 * q[o + 2];
          if (FRAME === 'czarny') { var v = 255 - L; v = v > 140 ? 236 : 24 + v * 0.15; q[o] = q[o + 1] = q[o + 2] = v; }
          else if (L > 115) { q[o] = 251; q[o + 1] = 250; q[o + 2] = 246; }
        }
        rcx.putImageData(px, 0, 0); inkI = rc; recolor = false;
      } catch (e) {}
    }
    if (ready(inkI) || inkI instanceof HTMLCanvasElement) {
      if (recolor) {
        var r = document.createElement('canvas'); r.width = Math.ceil(m.W * s); r.height = Math.ceil(m.H * s);
        var rx = r.getContext('2d'); rx.drawImage(inkI, 0, 0, r.width, r.height);
        rx.globalCompositeOperation = 'source-in'; rx.fillStyle = d.ink; rx.fillRect(0, 0, r.width, r.height);
        ctx.drawImage(r, ox, oy, m.W * s, m.H * s);
      } else ctx.drawImage(inkI, ox, oy, m.W * s, m.H * s);
    }
    // przelicznik px pliku -> px canvasu (do tekstow wstawianych przez kreator)
    return { m: m, X: function (px) { return ox + px * s; }, Y: function (px) { return oy + px * s; }, S: s };
  }

  var T = {};

  // N1 — Twoj pupil: imie lukiem (styl college), wyciety pupil na srodku, EST. rok
  // ================= NOWE WZORY 11.10 (folder ideas): pupil z odrecznym imieniem, imie powtorzone, gromadka pupili =================
  // wyciety pupil z filtrem stylu (kolor / cz-b / vintage)
  function cutTone(ph) {
    var s = ph.cut;
    if (!s || !TONE || !TONE_F[TONE]) return s;
    var key = '_kcTone_' + TONE; if (s[key]) return s[key];
    var c = document.createElement('canvas'); c.width = s.width; c.height = s.height; var x = c.getContext('2d');
    if (CAN_FILTER) x.filter = TONE_F[TONE]; x.drawImage(s, 0, 0); if (!CAN_FILTER) pixTone(x, c.width, c.height, TONE_F[TONE]);
    s[key] = c; return c;
  }
  // pupil (wyciety) albo stan posredni: zdjecie + "wycinam tlo" / puste pole
  function petAt(ctx, ph, x, y, w, h, alignY, ink, W, H, Wcm, Hcm, q) {
    if (ph && ph.cut) {
      var r = drawContain(ctx, cutTone(ph), x, y, w, h, alignY || 'bottom');
      if (q) q.push({ ph: ph, wCm: r.w / W * Wcm, hCm: r.h / H * Hcm, cut: true });
      return r;
    }
    if (ph && ph.img) {
      drawPhoto(ctx, ph, x + w * 0.1, y + h * 0.1, w * 0.8, h * 0.8);
      ctx.save(); ctx.fillStyle = ink; ctx.font = font(600, Math.max(10, w * 0.06), 'Hanken Grotesk'); ctx.textAlign = 'center';
      ctx.fillText(ph.cutError ? 'Nie udało się wyciąć tła' : 'Wycinam tło…', x + w / 2, y + h - w * 0.02); ctx.restore();
      return null;
    }
    slot(ctx, x + w * 0.1, y + h * 0.1, w * 0.8, h * 0.8, 0, ink);
    return null;
  }
  // napis po luku (litera po literze), opcjonalnie gradient + obrys
  function archText(ctx, text, cx, baseY, R, size, family, weight, fill, outline, outlineW, tr) {
    ctx.save(); ctx.font = font(weight, size, family); ctx.textAlign = 'center'; ctx.textBaseline = 'alphabetic'; ctx.lineJoin = 'round';
    var chars = Array.from(text), ws = chars.map(function (c) { return ctx.measureText(c).width + size * (tr || 0); });
    var tot = ws.reduce(function (a, b) { return a + b; }, 0), ang = -tot / R / 2, cy = baseY + R;
    chars.forEach(function (ch, i) {
      var a = ang + ws[i] / 2 / R;
      ctx.save(); ctx.translate(cx + R * Math.sin(a), cy - R * Math.cos(a)); ctx.rotate(a);
      if (outline) { ctx.lineWidth = outlineW; ctx.strokeStyle = outline; ctx.strokeText(ch, 0, 0); }
      ctx.fillStyle = fill; ctx.fillText(ch, 0, 0);
      ctx.restore(); ang += ws[i] / R;
    });
    ctx.restore();
  }
  var INK4 = { 'Czerwony': '#C8102E', 'Czarny': '#151515', 'Biały': '#FFFFFF', 'Różowy': '#E8578F', 'Granatowy': '#1E2A4A', 'Brązowy': '#6B4226' };
  function inkOf(name, d, def) { return INK4[name] || def; } // kolor dokladnie jak wybral klient (11.10: bialy napis musi byc bialy)

  // 7) "Chata." - pupil z imieniem pisanym odrecznie nad glowa
  T.pupilscript = {
    id: 'pupilscript', name: 'Pupil z imieniem pisanym odręcznie', w: 28, h: 33, cutout: true,
    fonts: ['Kaushan Script', 'Playfair Display', 'Pacifico', 'Hanken Grotesk'],
    draw: function (ctx, W, H, d) {
      var u = W / 100, ph = (d.photos || [])[0], name = String(d.name || '').trim(), q = [];
      var fam = { 'Odręczne': 'Kaushan Script', 'Eleganckie': 'Playfair Display', 'Zaokrąglone': 'Pacifico' }[d.font] || 'Playfair Display';
      var col = inkOf(d.nameColor || 'Czerwony', d, '#C8102E'), top = 4 * u;
      if (name) {
        var txt = name + (d.dot === 'nie' ? '' : '.'), it = fam === 'Playfair Display';
        var size = fit(ctx, txt, 700, 20 * u, fam, W * 0.74, 0, it);
        ctx.save(); ctx.fillStyle = col; ctx.textAlign = 'center'; ctx.textBaseline = 'alphabetic';
        ctx.fillText(txt, W / 2, top + size * 0.9); ctx.restore();
        top += size * 1.1;
      }
      petAt(ctx, ph, W * 0.08, top, W * 0.84, H - top - 2 * u, 'bottom', d.ink, W, H, this.w, this.h, q);
      d._q = q;
    }
  };

  // 6) "MAFFIN" - imie powtorzone wiele razy, pupil na srodku
  T.pupilrepeat = {
    id: 'pupilrepeat', name: 'Imię pupila powtórzone z pupilem', w: 28, h: 34, cutout: true,
    fonts: ['Anton', 'Hanken Grotesk'],
    draw: function (ctx, W, H, d) {
      var u = W / 100, ph = (d.photos || [])[0], name = String(d.name || 'PUPIL').trim().toUpperCase(), q = [];
      var rows = Math.max(5, Math.min(9, +d.rows || 7)), ink = d.ink, rowH = (H - 10 * u) / rows;
      var size = rowH * 1.08;
      ctx.save(); ctx.font = font(400, size, 'Anton'); ctx.textBaseline = 'middle'; ctx.lineJoin = 'round';
      var tw = textW(ctx, name, 0.02), sx = (W * 0.96) / Math.max(1, tw); // rozciagniecie napisu na cala szerokosc (jak na wzorze)
      for (var i = 0; i < rows; i++) {
        var y = 2 * u + rowH * (i + 0.5), solid = i === 0 || i === rows - 1 || d.outline === 'brak';
        ctx.save(); ctx.translate(W / 2, y); ctx.scale(sx, 1);
        ctx.fillStyle = ink; ctx.strokeStyle = ink; ctx.lineWidth = Math.max(1, size * 0.03) / sx;
        textAt(ctx, name, 0, 0, 0.02, 'center', solid ? 'fill' : 'stroke');
        ctx.restore();
      }
      ctx.restore();
      // pupil na srodku, duzy, nachodzi na srodkowe napisy
      petAt(ctx, ph, W * 0.12, rowH * 0.75, W * 0.76, H - rowH * 1.95 - 2 * u, 'bottom', ink, W, H, this.w, this.h, q);
      // stopka: maly napis z lapka
      var small = String(d.small != null ? d.small : name).trim();
      if (small) {
        ctx.save(); ctx.fillStyle = ink; ctx.font = font(700, 3.2 * u, 'Hanken Grotesk'); ctx.textBaseline = 'middle';
        var sy = H - 3.5 * u; textAt(ctx, small, W / 2 - 4 * u, sy, 0.12, 'right'); textAt(ctx, small, W / 2 + 4 * u, sy, 0.12, 'left');
        heart(ctx, W / 2, sy + 0.4 * u, 3.2 * u, ink); ctx.restore();
      }
      d._q = q;
    }
  };

  // 5) "FLORENCIA" - gromadka 1-6 pupili, imie w luku (vintage), rozowa poswiata
  var GROUP = [ // [srodek x, dol y, szerokosc] jako ulamki; kolejnosc zdjec: 1 = glowny z przodu
    [0.5, 1.0, 0.54], [0.25, 0.9, 0.4], [0.75, 0.9, 0.4], [0.36, 0.66, 0.34], [0.64, 0.66, 0.34], [0.5, 0.56, 0.32]];
  T.pupile = {
    id: 'pupile', name: 'Gromadka pupili z imieniem w łuku', w: 30, h: 33, cutout: true,
    fonts: ['Playfair Display', 'Graduate', 'Hanken Grotesk'],
    draw: function (ctx, W, H, d) {
      var u = W / 100, ph = (d.photos || []).filter(function (p) { return p; }), name = String(d.name || '').trim().toUpperCase(), q = [];
      var n = Math.max(1, Math.min(6, ph.length || 1)), top = name ? 22 * u : 4 * u, area = H - top;
      // poswiata
      var glow = { 'Różowa': '#F3A6B9', 'Niebieska': '#9EC5F0', 'Złota': '#F2D48A', 'Brak': '' }[d.glow || 'Różowa'];
      if (glow) {
        var gy = top + area * 0.62, g = ctx.createRadialGradient(W / 2, gy, W * 0.04, W / 2, gy, W * 0.5);
        g.addColorStop(0, hexA(glow, 0.8)); g.addColorStop(0.55, hexA(glow, 0.4)); g.addColorStop(1, hexA(glow, 0));
        ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
      }
      // od tylu do przodu
      var order = [5, 4, 3, 2, 1, 0].filter(function (i) { return i < n; });
      order.forEach(function (i) {
        var s = GROUP[i], k = n === 1 ? 1.6 : n === 2 ? 1.25 : n === 3 ? 1.1 : 1, w = W * s[2] * k, h = area * Math.min(0.98, s[2] * 1.6 * k);
        var cx = W * (n === 2 ? (i === 0 ? 0.62 : 0.32) : n === 3 && i > 0 ? (i === 1 ? 0.26 : 0.74) : s[0]), by = top + area * Math.min(1, s[1] + (n <= 3 ? 0.04 : 0));
        petAt(ctx, ph[i] || null, cx - w / 2, by - h, w, h, 'bottom', d.ink, W, H, this.w, this.h, q);
      }, this);
      // imie w luku: gradient vintage + ciemny obrys
      if (name) {
        var size = fit(ctx, name, 700, 21 * u, 'Playfair Display', W * 0.94, 0.03);
        var c1 = { 'Różowy': '#7A2E3A', 'Złoty': '#6B4E16', 'Czarny': '#151515', 'Biały': '#FFFFFF' }[d.nameColor || 'Różowy'] || '#7A2E3A';
        var c2 = { 'Różowy': '#F2C4CD', 'Złoty': '#F6DE9B', 'Czarny': '#5A5A5A', 'Biały': '#DADADA' }[d.nameColor || 'Różowy'] || '#F2C4CD';
        var gr = ctx.createLinearGradient(0, 4 * u, 0, 4 * u + size); gr.addColorStop(0, c2); gr.addColorStop(0.55, c1); gr.addColorStop(1, c1);
        archText(ctx, name, W / 2, 3 * u + size * 0.95, W * 1.5, size, 'Playfair Display', 700, gr, d.dark ? '#FFFFFF' : '#2A1418', size * 0.1, 0.03);
      }
      d._q = q;
    }
  };

  // 8) pupil jako ilustracja (bluza, plecy) + male imie pisane odrecznie; finalna ilustracje robimy po zamowieniu (AI + korekta)
  function illus(ph) {
    var s = ph.cut; if (!s) return null; if (s._kcIll) return s._kcIll;
    var w = s.width, h = s.height, pad = Math.round(Math.max(w, h) * 0.025);
    var c = document.createElement('canvas'); c.width = w + pad * 2; c.height = h + pad * 2; var x = c.getContext('2d');
    // obrys: sylwetka przesunieta dookola
    var m = document.createElement('canvas'); m.width = w; m.height = h; var mx = m.getContext('2d');
    mx.drawImage(s, 0, 0); mx.globalCompositeOperation = 'source-in'; mx.fillStyle = '#1B1410'; mx.fillRect(0, 0, w, h);
    for (var a = 0; a < 16; a++) x.drawImage(m, pad + Math.cos(a / 8 * Math.PI) * pad * 0.7, pad + Math.sin(a / 8 * Math.PI) * pad * 0.7);
    // kolory uproszczone (posteryzacja) + wiecej nasycenia
    var t = document.createElement('canvas'); t.width = w; t.height = h; var tx = t.getContext('2d');
    if (CAN_FILTER) tx.filter = 'saturate(1.5) contrast(1.15)'; tx.drawImage(s, 0, 0);
    var im = tx.getImageData(0, 0, w, h), p = im.data, L = 5, st = 255 / (L - 1);
    for (var i = 0; i < p.length; i += 4) { p[i] = Math.round(p[i] / st) * st; p[i + 1] = Math.round(p[i + 1] / st) * st; p[i + 2] = Math.round(p[i + 2] / st) * st; }
    tx.putImageData(im, 0, 0); x.drawImage(t, pad, pad);
    s._kcIll = c; return c;
  }
  T.pupilart = {
    id: 'pupilart', name: 'Pupil jako ilustracja z imieniem', w: 30, h: 32, cutout: true,
    fonts: ['Kaushan Script', 'Pacifico', 'Hanken Grotesk'],
    draw: function (ctx, W, H, d) {
      var u = W / 100, ph = (d.photos || [])[0], name = String(d.name || '').trim(), q = [];
      var fam = { 'Odręczne': 'Kaushan Script', 'Zaokrąglone': 'Pacifico' }[d.font] || 'Kaushan Script';
      var col = inkOf(d.nameColor, d, d.dark ? '#FFFFFF' : '#151515'), top = 3 * u;
      if (name) {
        var size = fit(ctx, name, 400, 11 * u, fam, W * 0.5, 0);
        ctx.save(); ctx.fillStyle = col; ctx.textAlign = 'center'; ctx.textBaseline = 'alphabetic'; ctx.font = font(400, size, fam);
        ctx.fillText(name, W * (d.namePos === 'środek' ? 0.5 : 0.66), top + size); ctx.restore();
        top += size * 1.25;
      }
      if (ph && ph.cut) {
        var r = drawContain(ctx, ph.art ? ph.cut : illus(ph), W * 0.06, top, W * 0.88, H - top - u, 'bottom');
        q.push({ ph: ph, wCm: r.w / W * this.w, hCm: r.h / H * this.h, cut: true });
      } else petAt(ctx, ph, W * 0.06, top, W * 0.88, H - top - u, 'bottom', col, W, H, this.w, this.h, q);
      d._q = q;
    }
  };


  // 9) 12.10 "vintage 90s" (wzor Etsy usera): wielki napis z gradientem, chmura z blyskawicami, 1-5 pupili (2 z tylu, 3 z przodu)
  var V90C = { 'Fioletowy': ['#4B1D78', '#8E5CC9', '#E9DDF7'], 'Niebieski': ['#12357A', '#4F86D9', '#DCE8FA'], 'Różowy': ['#8E1E52', '#E05C97', '#FADCE9'],
    'Czerwony': ['#7A0F16', '#D9444C', '#FADADB'], 'Zielony': ['#0F5A2B', '#3FAF67', '#DAF3E2'], 'Pomarańczowy': ['#8A3A06', '#F08A2C', '#FDE6D0'] };
  // kolejnosc: najpierw przod (zdjecie 1 = srodek z przodu), rysujemy od tylu
  var V90L = { 1: [[0.5, 1, 0.78]], 2: [[0.31, 1, 0.5], [0.69, 1, 0.5]], 3: [[0.5, 1, 0.46], [0.24, 0.97, 0.42], [0.76, 0.97, 0.42]],
    4: [[0.3, 1, 0.44], [0.7, 1, 0.44], [0.33, 0.66, 0.4], [0.67, 0.66, 0.4]],
    5: [[0.5, 1, 0.4], [0.2, 0.97, 0.36], [0.8, 0.97, 0.36], [0.35, 0.62, 0.38], [0.65, 0.62, 0.38]] };
  function rng(seed) { return function () { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }; }
  function bolt(ctx, r, x, y, len, ang, wd, col) {
    var pts = [[x, y]], n = 7;
    for (var i = 1; i <= n; i++) { var t = len * i / n, j = (r() - 0.5) * len * 0.22; pts.push([x + Math.cos(ang) * t - Math.sin(ang) * j, y + Math.sin(ang) * t + Math.cos(ang) * j]); }
    ctx.save(); ctx.lineJoin = 'round'; ctx.lineCap = 'round';
    [[wd * 3.2, hexA(col, 0.35)], [wd * 1.6, col], [wd * 0.6, '#FFFFFF']].forEach(function (s) {
      ctx.strokeStyle = s[1]; ctx.lineWidth = s[0]; ctx.beginPath(); pts.forEach(function (p, i) { i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]); }); ctx.stroke();
    });
    // odnoga
    var k = pts[3], a2 = ang + (r() > 0.5 ? 0.7 : -0.7); ctx.strokeStyle = col; ctx.lineWidth = wd;
    ctx.beginPath(); ctx.moveTo(k[0], k[1]); ctx.lineTo(k[0] + Math.cos(a2) * len * 0.25, k[1] + Math.sin(a2) * len * 0.25); ctx.stroke();
    ctx.restore();
  }
  function sparkle(ctx, x, y, s, col) {
    ctx.save(); ctx.fillStyle = col; ctx.beginPath();
    ctx.moveTo(x, y - s); ctx.quadraticCurveTo(x, y, x + s * 0.35, y); ctx.quadraticCurveTo(x, y, x, y + s); ctx.quadraticCurveTo(x, y, x - s * 0.35, y); ctx.quadraticCurveTo(x, y, x, y - s);
    ctx.moveTo(x - s * 0.6, y); ctx.quadraticCurveTo(x, y, x, y - s * 0.2); ctx.quadraticCurveTo(x, y, x + s * 0.6, y); ctx.quadraticCurveTo(x, y, x, y + s * 0.2); ctx.closePath();
    ctx.fill(); ctx.restore();
  }
  T.pupilvintage = {
    id: 'pupilvintage', name: 'Pupile w stylu vintage z wielkim napisem', w: 30, h: 36, cutout: true,
    fonts: ['Playfair Display', 'Hanken Grotesk'],
    draw: function (ctx, W, H, d) {
      var u = W / 100, ph = (d.photos || []).filter(function (p) { return p; }), name = String(d.name || '').trim().toUpperCase(), q = [];
      var C = V90C[d.color90 || 'Fioletowy'] || V90C['Fioletowy'], n = Math.max(1, Math.min(5, ph.length || 1));
      var top = name ? 30 * u : 6 * u, area = H - top - 1 * u, r = rng(7 + n);
      // chmura: duzo miekkich plam w kolorze, poszarpane brzegi
      var cx = W / 2, cy = top + area * 0.42, rx = W * 0.47, ry = area * 0.5;
      ctx.save();
      for (var i = 0; i < 110; i++) {
        var a = r() * Math.PI * 2, rr = 0.25 + 0.75 * Math.sqrt(r()), x = cx + Math.cos(a) * rx * rr * 0.8, y = cy + Math.sin(a) * ry * rr * 0.8, s = (0.08 + r() * 0.12) * W;
        var g = ctx.createRadialGradient(x, y, 0, x, y, s); g.addColorStop(0, hexA(C[1], 0.32)); g.addColorStop(1, hexA(C[1], 0));
        ctx.fillStyle = g; ctx.fillRect(x - s, y - s, s * 2, s * 2);
      }
      var g0 = ctx.createRadialGradient(cx, cy, 0, cx, cy, rx); g0.addColorStop(0, hexA(C[0], 0.55)); g0.addColorStop(0.7, hexA(C[0], 0.25)); g0.addColorStop(1, hexA(C[0], 0));
      ctx.fillStyle = g0; ctx.fillRect(cx - rx, cy - rx, rx * 2, rx * 2);
      ctx.restore();
      // blyskawice + iskry
      if (d.bolts !== 'nie') {
        for (var b = 0; b < 9; b++) {
          var side = b % 2 ? 1 : -1, bx = cx + side * rx * (0.45 + r() * 0.4), by = top - 4 * u + r() * area * 0.75, ang = Math.PI / 2 + (r() - 0.5) * 1.6;
          bolt(ctx, r, bx, by, (0.1 + r() * 0.12) * W, ang, 0.45 * u, C[2]);
        }
        for (var sp = 0; sp < 9; sp++) sparkle(ctx, cx + (r() - 0.5) * rx * 2.2, top - 6 * u + r() * area, (1.2 + r() * 1.6) * u, '#FFFFFF');
      }
      // pupile
      var L = V90L[n];
      for (var k = n - 1; k >= 0; k--) {
        var s0 = L[k], w = W * s0[2] * (n > 1 ? 0.9 : 1), h = Math.min(area * 0.98, w * 1.35), x0 = W * s0[0] - w / 2, y0 = top + area * s0[1] - h;
        petAt(ctx, ph[k] || null, x0, y0, w, h, 'bottom', d.ink, W, H, this.w, this.h, q);
      }
      // wielki napis: wysoki szeryfowy, gradient od ciemnego do jasnego, bialy srodkowy obrys, skrajne litery wyzsze
      if (name) {
        ctx.save(); var size = 20 * u; ctx.font = font(700, size, 'Playfair Display');
        var chars = Array.from(name), tr = size * 0.02, ws = chars.map(function (c) { return ctx.measureText(c).width + tr; });
        var tot = ws.reduce(function (a, b) { return a + b; }, 0), sx = Math.min(1.25, (W * 0.92) / tot);
        var sy = 1.55, half = tot * sx / 2, x = W / 2 - half, ymid = 3 * u + size * 0.36 * sy * 1.18 + 1 * u;
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.lineJoin = 'round';
        chars.forEach(function (ch, i) {
          var cw = ws[i] * sx, px = x + cw / 2, t = Math.abs(px - W / 2) / Math.max(1, half), k2 = 1 + 0.22 * t * t;
          ctx.save(); ctx.translate(px, ymid); ctx.scale(sx, sy * k2);
          var gr = ctx.createLinearGradient(0, -size * 0.38, 0, size * 0.38);
          gr.addColorStop(0, C[0]); gr.addColorStop(0.45, C[1]); gr.addColorStop(1, C[2]);
          ctx.lineWidth = size * 0.11; ctx.strokeStyle = '#1A0F24'; ctx.strokeText(ch, 0, 0);
          ctx.lineWidth = size * 0.05; ctx.strokeStyle = '#FFFFFF'; ctx.strokeText(ch, 0, 0);
          ctx.fillStyle = gr; ctx.fillText(ch, 0, 0);
          ctx.restore(); x += cw;
        });
        ctx.restore();
        if (d.bolts !== 'nie') { sparkle(ctx, W * 0.86, 6 * u, 2.2 * u, '#FFFFFF'); sparkle(ctx, W * 0.17, 25 * u, 1.6 * u, '#FFFFFF'); }
      }
      d._q = q;
    }
  };
  T.pupil = {
    id: 'pupil', name: 'Twój pupil ze zdjęcia', w: 28, h: 30, cutout: true,
    fonts: ['Graduate', 'Hanken Grotesk', 'Playfair Display'],
    draw: function (ctx, W, H, d) {
      var u = W / 100, ink = d.ink, name = (d.name || '').toUpperCase(), ph = (d.photos || [])[0];
      var accent = d.dark ? '#FFFFFF' : (d.garment && lum(d.garment) > 0.75 ? '#7A1F2B' : ink);
      // imie po luku
      if (name) {
        // user 09.10: dlugie imiona wychodzily poza wzor -> dopasowanie do 82% szerokosci (z miejscem na obrys), luk liczony tak samo
        var R = W * 0.95, cx = W / 2, cy = 30 * u + R, size = fit(ctx, name, 400, 24 * u, 'Graduate', W * 0.82, 0.03);
        size = Math.min(size, (W * 0.82) / Math.max(1, textW(ctx, name, 0.03)) * size);
        ctx.font = font(400, size, 'Graduate');
        var chars = Array.from(name), ws = chars.map(function (c) { return ctx.measureText(c).width + size * 0.03; });
        var tot = ws.reduce(function (a, b) { return a + b; }, 0), ang = -tot / R / 2;
        ctx.save(); ctx.textAlign = 'center'; ctx.textBaseline = 'alphabetic'; ctx.lineJoin = 'round';
        chars.forEach(function (ch, i) {
          var a = ang + ws[i] / 2 / R;
          ctx.save(); ctx.translate(cx + R * Math.sin(a), cy - R * Math.cos(a)); ctx.rotate(a);
          ctx.lineWidth = size * 0.16; ctx.strokeStyle = d.dark ? '#1C1C1E' : '#FFFFFF'; ctx.strokeText(ch, 0, 0);
          ctx.lineWidth = size * 0.07; ctx.strokeStyle = accent; ctx.strokeText(ch, 0, 0);
          ctx.fillStyle = d.dark ? hexA('#FFFFFF', 0.0) : '#FFFFFF'; ctx.fillText(ch, 0, 0);
          ctx.restore();
          ang += ws[i] / R;
        });
        ctx.restore();
      }
      // pupil
      var top = name ? 22 * u : 6 * u, boxH = H - top - 4 * u, boxW = W * 0.62;
      if (ph && ph.cut) {
        var cutSrc = ph.cut;
        if (TONE && TONE_F[TONE]) { var tc = document.createElement('canvas'); tc.width = ph.cut.width; tc.height = ph.cut.height; var tcx = tc.getContext('2d'); if (CAN_FILTER) tcx.filter = TONE_F[TONE]; tcx.drawImage(ph.cut, 0, 0); if (!CAN_FILTER) pixTone(tcx, tc.width, tc.height, TONE_F[TONE]); cutSrc = tc; }
        var r = drawContain(ctx, cutSrc, (W - boxW) / 2, top, boxW, boxH, 'bottom');
        d._q = [{ ph: ph, wCm: r.w / W * this.w, hCm: r.h / H * this.h, cut: true }];
      } else if (ph && ph.img) {
        drawPhoto(ctx, ph, W * 0.25, top + 6 * u, W * 0.5, boxH - 6 * u);
        ctx.fillStyle = ink; ctx.font = font(600, 3.4 * u, 'Hanken Grotesk'); ctx.textAlign = 'center';
        ctx.fillText(ph.cutError ? 'Nie udało się wyciąć tła' : 'Wycinam tło…', W / 2, H - 1 * u);
      } else slot(ctx, W * 0.25, top + 6 * u, W * 0.5, boxH - 6 * u, 0, ink);
      // EST. rok po bokach
      var yr = yearOf(d.date);
      if (yr) {
        ctx.fillStyle = ink; ctx.font = font(500, 4.6 * u, 'Playfair Display'); ctx.textBaseline = 'middle';
        textAt(ctx, 'EST.', 4 * u, H * 0.62, 0.06, 'left'); textAt(ctx, yr, W - 4 * u, H * 0.62, 0.06, 'right');
        ctx.textBaseline = 'alphabetic';
      }
    }
  };

  // N2 — Kolaz z imieniem (plecy): napis x3 (pelny + 2 kontury), siatka zdjec, kod kreskowy + since, imie
  T.kolaz = {
    id: 'kolaz', name: 'Kolaż zdjęć z imieniem', w: 30, h: 40,
    fonts: ['Archivo Black', 'Hanken Grotesk'],
    draw: function (ctx, W, H, d) {
      var u = W / 100, word = (d.word || 'ONLY YOU').toUpperCase(), ink = d.ink;
      var wc = d.wordColor === 'Czerwony' ? '#C1121F' : ink;
      var size = fit(ctx, word, 400, 15 * u, 'Archivo Black', W * 0.98, -0.01), lh = size * 0.86, y = size * 0.82;
      ctx.lineJoin = 'round';
      var reps = d.reps === 1 ? 1 : 3;
      for (var i = 0; i < reps; i++) {
        ctx.font = font(400, size, 'Archivo Black');
        if (i === 0) { ctx.fillStyle = wc; textAt(ctx, word, W / 2, y, -0.01, 'center'); }
        else { ctx.strokeStyle = wc; ctx.lineWidth = Math.max(1, size * 0.035); textAt(ctx, word, W / 2, y, -0.01, 'center', 'stroke'); }
        y += lh;
      }
      // siatka zdjec: 3 rzedy, uklad zalezny od liczby zdjec
      var ph = (d.photos || []).filter(function (p) { return p && p.img; }), n = Math.max(ph.length, 1);
      // user 09.10: zdjecia stykaja sie, bez odstepow
      var gx = ({ waskie: 1.2, szerokie: 3 })[d.gap] * u || 0, top = y - lh + size * 0.32, bottom = H - 11 * u, gh = bottom - top, rows;
      var plans = { 1: [[1]], 2: [[1], [1]], 3: [[1], [1, 1]], 4: [[1, 1], [1, 1]], 5: [[1, 1], [1], [1, 1]], 6: [[1, 1], [1, 1], [1, 1]] };
      rows = plans[Math.min(6, n)];
      var rh = (gh - gx * (rows.length - 1)) / rows.length, k = 0, yy = top;
      d._q = [];
      rows.forEach(function (row) {
        var cw = (W - gx * (row.length - 1)) / row.length, xx = 0;
        row.forEach(function () {
          photoOr(ctx, ph[k], xx, yy, cw + 0.6, rh + 0.6, k + 1, ink); // +0.6 px: bez jasnych szczelin na stykach
          if (ph[k]) d._q.push({ ph: ph[k], wCm: cw / W * 30, hCm: rh / H * 40 });
          k++; xx += cw + gx;
        });
        yy += rh + gx;
      });
      // kod kreskowy + since (lewo), imie (prawo)
      // user 09.10: kolor dolnych napisow (imie, since, kod) wybierany tak jak gornego
      var by = H - 9 * u, bc = d.bottomColor === 'Czerwony' ? '#C1121F' : ink;
      barcode(ctx, 0, by, 26 * u, 5.5 * u, (d.name || '') + (d.since || ''), bc);
      ctx.fillStyle = bc; ctx.font = font(700, 2.6 * u, 'Hanken Grotesk'); ctx.textBaseline = 'alphabetic';
      if (d.since) textAt(ctx, 'since ' + d.since, 0, H - 0.6 * u, 0.02, 'left');
      if (d.name) { fit(ctx, d.name.toUpperCase(), 800, 4.6 * u, 'Archivo Black', W * 0.5, 0.02); textAt(ctx, d.name.toUpperCase(), W, H - 4.2 * u, 0.02, 'right'); }
      if (d.tagline) { ctx.font = font(500, 2.4 * u, 'Hanken Grotesk'); textAt(ctx, d.tagline, W, H - 0.6 * u, 0.02, 'right'); }
    }
  };

  // N3 — Rysunek dziecka: kartka usunieta, kolory 1:1
  // czarne/szare kreski (flamaster, olowek) -> biale, zeby byly widoczne na ciemnym ubraniu
  function whiteLines(src) {
    if (src._kcWhite) return src._kcWhite;
    var c = document.createElement('canvas'); c.width = src.width; c.height = src.height; var x = c.getContext('2d'); x.drawImage(src, 0, 0);
    var id; try { id = x.getImageData(0, 0, c.width, c.height); } catch (e) { return src; }
    var p = id.data;
    for (var k = 0; k < p.length; k += 4) { if (!p[k + 3]) continue; var mx = Math.max(p[k], p[k + 1], p[k + 2]), mn = Math.min(p[k], p[k + 1], p[k + 2]);
      if (mx < 110 && mx - mn < 40) { var v = 255 - mx * 0.35; p[k] = p[k + 1] = p[k + 2] = v; } }
    x.putImageData(id, 0, 0); c.naturalWidth = c.width; c.naturalHeight = c.height; src._kcWhite = c; return c;
  }
  T.rysunek = {
    id: 'rysunek', name: 'Rysunek dziecka', w: 28, h: 28, paper: true,
    fonts: ['Hanken Grotesk'],
    draw: function (ctx, W, H, d) {
      var ph = (d.photos || [])[0];
      if (!ph || !ph.img) { slot(ctx, W * 0.1, H * 0.1, W * 0.8, H * 0.8, 0, d.ink); return; }
      var PS = { delikatne: 0.7, normalne: 1.25, mocne: 1.8 }, mode = d.paper || 'normalne';
      var src = (d.keepPaper || mode === 'brak') ? ph.img : paperToAlpha(ph.img, d.paperStrength || PS[mode] || 1.25);
      if (d.dark && d.lines !== 'czarne' && mode !== 'brak') src = whiteLines(src);
      var r = drawContain(ctx, src, 0, 0, W, H, 'center');
      d._q = [{ ph: { img: src }, wCm: r.w / W * this.w, hCm: r.h / H * this.h }];
    }
  };

  // N4 — Best Dad: napis x3 (pelny + kontury), 2x2 zdjecia cz-b, kod + imie
  T.bestdad = {
    id: 'bestdad', name: 'Best Dad – zdjęcia i imię', w: 24, h: 40.8,
    fonts: ['Archivo Black', 'Hanken Grotesk'],
    draw: function (ctx, W, H, d) {
      // greenscreen usera: napis x3, 4 zdjecia cz-b, kod kreskowy; kreator dopisuje imie i nazwisko (z prawej) + SINCE data (pod kodem)
      var g = gsDraw(this, ctx, W, H, d, 'grayscale(1) contrast(1.08)');
      if (g) {
        var G = g.m.grid, B = g.m.below || { x: G.x, y: G.y + G.h + 40, w: G.w * 0.37, h: 100 };
        var bx = g.X(B.x), by = g.Y(B.y), bw = B.w * g.S, bh = B.h * g.S, right = g.X(G.x + G.w);
        ctx.fillStyle = d.ink; ctx.textBaseline = 'alphabetic';
        if (d.under) {
          var sn = /^\s*(since|est)/i.test(d.under) ? d.under.toUpperCase() : 'SINCE ' + d.under.toUpperCase();
          fit(ctx, sn, 400, bh * 0.27, 'Archivo Black', bw, 0.06);
          textAt(ctx, sn, bx, by + bh + bh * 0.36, 0.06, 'left');
        }
        if (d.name) {
          var words = d.name.trim().toUpperCase().split(/\s+/), lines = words.length > 1 ? [words[0], words.slice(1).join(' ')] : words;
          var maxW = right - (bx + bw) - bh * 0.4, fs = bh * 0.42;
          lines.forEach(function (l) { fs = Math.min(fs, fit(ctx, l, 400, fs, 'Archivo Black', maxW, 0.04)); });
          ctx.font = font(400, fs, 'Archivo Black');
          var lh = fs * 1.08, y0 = by + bh * 0.62 + fs * 0.74 - (lines.length - 1) * lh / 2;
          lines.forEach(function (l, i) { textAt(ctx, l, right, y0 + i * lh, 0.04, 'right'); });
        }
        return;
      }
      var u = W / 100, ink = d.ink, word = (d.word || 'BEST DAD').toUpperCase();
      var size = fit(ctx, word, 400, 15 * u, 'Archivo Black', W * 0.98, 0), lh = size * 0.86, y = size * 0.82;
      ctx.lineJoin = 'round';
      for (var i = 0; i < 3; i++) {
        ctx.font = font(400, size, 'Archivo Black');
        if (i === 0) { ctx.fillStyle = ink; textAt(ctx, word, W / 2, y, 0, 'center'); }
        else { ctx.strokeStyle = ink; ctx.lineWidth = Math.max(1, size * 0.035); textAt(ctx, word, W / 2, y, 0, 'center', 'stroke'); }
        y += lh;
      }
      var top = y - lh + size * 0.3, bottom = H - 8 * u, g = 1.2 * u, cw = (W - g) / 2, rh = (bottom - top - g) / 2, ph = d.photos || [];
      d._q = [];
      for (var k = 0; k < 4; k++) {
        var x = (k % 2) * (cw + g), yy = top + Math.floor(k / 2) * (rh + g);
        photoOr(ctx, ph[k], x, yy, cw, rh, k + 1, ink, 'grayscale(1) contrast(1.08)');
        if (ph[k] && ph[k].img) d._q.push({ ph: ph[k], wCm: cw / W * this.w, hCm: rh / H * this.h });
      }
      barcode(ctx, 0, H - 6 * u, 24 * u, 4.6 * u, d.name || 'DAD', ink);
      ctx.fillStyle = ink;
      if (d.name) { fit(ctx, d.name.toUpperCase(), 400, 5.2 * u, 'Archivo Black', W * 0.6, 0.02); textAt(ctx, d.name.toUpperCase(), W, H - 2.2 * u, 0.02, 'right'); }
      if (d.under) { ctx.font = font(600, 2.4 * u, 'Hanken Grotesk'); textAt(ctx, d.under, 0, H - 0.2 * u, 0.04, 'left'); }
    }
  };

  // N5 — Best Dad Ever: szachownica u gory i na dole, 3 pionowe zdjecia cz-b, duzy napis z obrysem
  T.bestdadever = {
    id: 'bestdadever', name: 'Best Dad Ever – 3 zdjęcia', w: 30, h: 31.2,
    fonts: ['Anton', 'Hanken Grotesk'],
    draw: function (ctx, W, H, d) {
      if (gsDraw(this, ctx, W, H, d, 'grayscale(1) contrast(1.1)')) return; // greenscreen usera (bialy/czarny)
      // user 09.10: na czarnym (ciemnym) produkcie projekt BIALY -> K = kolor rysunku, L = kolor "dziur" (wypelnienie napisu)
      var u = W / 100, ink = d.ink, ph = d.photos || [], cell = 4.2 * u;
      var K = d.dark ? '#FFFFFF' : '#111111', L = d.dark ? '#111111' : '#FFFFFF';
      function checker(y, rows) { // drugie pole szachownicy = przezroczyste (kolor ubrania)
        for (var r = 0; r < rows; r++) for (var c = 0; c * cell < W; c++) {
          if ((r + c) % 2) continue;
          ctx.fillStyle = K; ctx.fillRect(c * cell, y + r * cell, Math.min(cell, W - c * cell), cell);
        }
      }
      checker(0, 2);
      var top = 2 * cell + 1.2 * u, bottom = H - 2 * cell - 6 * u, g = 1.4 * u, pw = (W - 2 * g) / 3;
      ctx.fillStyle = K; ctx.fillRect(0, top - 1.2 * u, W, bottom - top + 2.4 * u);
      d._q = [];
      for (var k = 0; k < 3; k++) {
        photoOr(ctx, ph[k], k * (pw + g), top, pw, bottom - top, k + 1, L, 'grayscale(1) contrast(1.1)');
        if (ph[k] && ph[k].img) d._q.push({ ph: ph[k], wCm: pw / W * this.w, hCm: (bottom - top) / H * this.h });
      }
      checker(H - 2 * cell, 2);
      // napis na styku zdjec i szachownicy
      var word = (d.word || 'BEST DAD EVER').toUpperCase(), size = fit(ctx, word, 400, 16 * u, 'Anton', W * 0.96, 0.01), y = H - 2 * cell + size * 0.35;
      ctx.font = font(400, size, 'Anton'); ctx.lineJoin = 'round';
      ctx.lineWidth = size * 0.16; ctx.strokeStyle = K; textAt(ctx, word, W / 2, y, 0.01, 'center', 'stroke');
      ctx.fillStyle = L; textAt(ctx, word, W / 2, y, 0.01, 'center');
      if (d.under) { ctx.fillStyle = ink; ctx.font = font(700, 3 * u, 'Hanken Grotesk'); textAt(ctx, d.under.toUpperCase(), W / 2, H + 0.1 * u - 0.1 * u, 0.2, 'center'); }
    }
  };

  // N6 / N6b — Zdjecia z dziecinstwa: 4 style ze zdjec produktu (d.style):
  //  'inicjaly'   2 polaroidy lekko obrocone, na dole odrecznie "A ♡ M" (inicjaly na ramkach)
  //  'podpis'     2 proste polaroidy obok siebie + napis odrecznie pod spodem ("I love you")
  //  'walentynki' 2 zdjecia stykajace sie bez ramek + czerwony odreczny napis na dole ("Happy Valentine's Day")
  //  'forever'    1 polaroid + napis maszynowy na ramce ("FOREVER YOUNG")
  // Zdjecia w oryginalnych kolorach (bez filtrow). Inicjaly: d.initials "A+M" / "A ♡ M" / "A M" albo d.ini1 + d.ini2.
  function splitInitials(d) {
    if (d.ini1 || d.ini2) return [d.ini1 || '', d.ini2 || ''];
    var s = String(d.initials || '').trim(); if (!s) return ['', ''];
    var p = s.split(/\s*(?:\+|&|♡|❤|♥|<3|i|\s)\s*/i).filter(Boolean);
    return [p[0] || '', p[1] || ''];
  }
  // Vintage polaroid (user 09.10, wzor "Forever Young"): postarzala, pomieta kartka (tex/polaroid-card|shade-N.png),
  // zdjecie cz-b w cieplym tonie z rysami (tex/polaroid-age.png). onCard(x, w, h, bot) = napis na ramce (dostaje te same zalamania).
  var TEX_BASE = 'tex/', VINTAGE = 'grayscale(1) sepia(0.45) contrast(1.06) brightness(0.96)';
  function polaroid(ctx, ph, cx, cy, pw, rot, n, q, Wcm, W, H, Hcm, variant, onCard, shp) { // shp.plain = bez filtra vintage
    shp = shp || { r: 1.2, side: 0.06, bot: 0.22 };
    var phH = pw * shp.r, side = pw * shp.side, bot = pw * shp.bot, v = variant || 1;
    var card = img(TEX_BASE + 'polaroid-card-' + v + '.png'), shade = img(TEX_BASE + 'polaroid-shade-' + v + '.png'), age = img(TEX_BASE + 'polaroid-age.png');
    var c = document.createElement('canvas'); c.width = Math.max(1, Math.ceil(pw)); c.height = Math.max(1, Math.ceil(phH));
    var x = c.getContext('2d'), cw = c.width, ch = c.height, wx = side, wy = side, ww = cw - 2 * side, wh = ch - side - bot;
    if (FRAME !== 'vintage') { x.fillStyle = FRAME === 'czarny' ? '#1C1B1A' : '#FBFAF6'; x.fillRect(0, 0, cw, ch); }
    else if (ready(card)) x.drawImage(card, 0, 0, cw, ch); else { x.fillStyle = '#E9E0CB'; x.fillRect(0, 0, cw, ch); }
    x.save(); x.globalCompositeOperation = 'source-atop';
    var plain = shp && shp.plain;
    if (ph && ph.img) drawPhoto(x, ph, wx, wy, ww, wh, plain ? null : VINTAGE);
    else {
      x.fillStyle = '#4A433B'; x.fillRect(wx, wy, ww, wh);
      x.fillStyle = 'rgba(236,228,210,0.75)'; x.font = font(600, ww * 0.09, 'Hanken Grotesk'); x.textAlign = 'center'; x.textBaseline = 'middle';
      x.fillText(n ? 'Zdjęcie ' + n : 'Zdjęcie', wx + ww / 2, wy + wh / 2);
    }
    if (ready(age) && !plain && !TONE) x.drawImage(age, wx, wy, ww, wh);
    if (FRAME === 'vintage') { x.strokeStyle = 'rgba(60,45,30,0.35)'; x.lineWidth = Math.max(1, pw * 0.003); x.strokeRect(wx, wy, ww, wh); }
    x.restore();
    if (onCard) { x.save(); onCard(x, cw, ch, bot); x.restore(); }
    if (ready(shade) && FRAME === 'vintage') {
      x.save(); x.globalCompositeOperation = 'soft-light'; x.drawImage(shade, 0, 0, cw, ch); x.restore();
      if (ready(card)) { x.save(); x.globalCompositeOperation = 'destination-in'; x.drawImage(card, 0, 0, cw, ch); x.restore(); }
    }
    ctx.save(); ctx.translate(cx, cy); ctx.rotate(rot * Math.PI / 180);
    ctx.shadowColor = 'rgba(0,0,0,0.28)'; ctx.shadowBlur = pw * 0.025; ctx.shadowOffsetY = pw * 0.008;
    ctx.drawImage(c, -pw / 2, -phH / 2, pw, phH); ctx.restore();
    if (ph && ph.img) q.push({ ph: ph, wCm: ww / W * Wcm, hCm: wh / H * Hcm });
    return { h: phH, bot: bot };
  }
  function heartPlus(ctx, hx, hy, hs, pen) { // serce z plusem (odrecznie, obrys)
    ctx.save(); ctx.strokeStyle = pen; ctx.lineWidth = hs * 0.09; ctx.lineJoin = 'round'; ctx.beginPath();
    ctx.moveTo(hx, hy + hs * 0.35);
    ctx.bezierCurveTo(hx - hs * 0.9, hy - hs * 0.25, hx - hs * 0.35, hy - hs * 0.95, hx, hy - hs * 0.4);
    ctx.bezierCurveTo(hx + hs * 0.35, hy - hs * 0.95, hx + hs * 0.9, hy - hs * 0.25, hx, hy + hs * 0.35);
    ctx.stroke(); ctx.lineWidth = hs * 0.07; ctx.beginPath();
    ctx.moveTo(hx - hs * 0.18, hy - hs * 0.15); ctx.lineTo(hx + hs * 0.18, hy - hs * 0.15); ctx.moveTo(hx, hy - hs * 0.33); ctx.lineTo(hx, hy + hs * 0.03); ctx.stroke(); ctx.restore();
  }
  // style z greenscreenow usera (09.10); teksty klienta w miejscach z gs.json (texts[]), na kartkach -> stale kolory
  var GSDZ = { inicjaly: 'dzinicjaly', podpis: 'dzpodpis', finding: 'dzfinding', forever2: 'dzforever2', forever: 'dzforever' };
  function gsHas(id) { return !!((global.KCApparelGS || {})[id]); }
  function gsText(ctx, g, i, txt, fam, weight, color, stroke) {
    var t = g.m.texts && g.m.texts[i]; if (!t || !txt) return;
    var capH = t.h * g.S, px = capH / 0.68;
    ctx.save(); ctx.fillStyle = color; ctx.textAlign = 'center'; ctx.textBaseline = 'alphabetic';
    px = fit(ctx, txt, weight, px, fam, t.w * g.S * 1.04, 0.04);
    var x = g.X(t.cx), y = g.Y(t.cy) + Math.min(capH, px * 0.72) / 2;
    if (t.ang) { ctx.translate(x, y); ctx.rotate(t.ang * Math.PI / 180); x = 0; y = 0; }
    textAt(ctx, txt, x, y, 0.04, 'center');
    if (stroke) { ctx.strokeStyle = color; ctx.lineWidth = px * stroke; ctx.lineJoin = 'round'; textAt(ctx, txt, x, y, 0.04, 'center', 'stroke'); }
    ctx.restore();
  }
  var TXTC = { 'Czarny': '#1C1A1A', 'Czerwony': '#C8102E', 'Różowy': '#C9798A', 'Brązowy': '#5A4330', 'Biały': '#F5F1EA' };
  var DZDEF = { podpis: 'I love you', finding: 'Finding you was always the plan ♡', forever2: 'Forever Young' };
  var DZFONT = { podpis: 'Allison', finding: 'Kaushan Script', forever2: 'Sacramento' };
  function normT(t) { return String(t || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function splitLines(txt, n) { // podzial na n wierszy o podobnej dlugosci ('|' = reczny podzial)
    if (txt.indexOf('|') >= 0) return txt.split('|').map(function (x) { return x.trim(); });
    var w = txt.split(/\s+/); if (n < 2 || w.length < 2) return [txt];
    if (n > 2 && txt.length > 34 && w.length >= 3) { // 3 wiersze: rownomiernie po dlugosci
      var tot = txt.length, out = [], cur = [], acc = 0;
      w.forEach(function (x, k) { cur.push(x); acc += x.length + 1; if (out.length < 2 && acc >= tot * (out.length + 1) / 3 && k < w.length - 1) { out.push(cur.join(' ')); cur = []; } });
      if (cur.length) out.push(cur.join(' '));
      return out;
    }
    var best = 1, bd = 1e9;
    for (var i = 1; i < w.length; i++) { var a = w.slice(0, i).join(' ').length, b = w.slice(i).join(' ').length, dd = Math.abs(a - b); if (dd < bd) { bd = dd; best = i; } }
    return [w.slice(0, best).join(' '), w.slice(best).join(' ')];
  }
  function gsTextBlock(ctx, g, i, txt, fam, color, big) {
    var t = g.m.texts && g.m.texts[i]; if (!t || !txt) return;
    var lines = splitLines(txt, t.lines || 1), capH = t.h * g.S * (big || 1), lh = capH * 1.45, y0 = g.Y(t.cy) - (Math.min(lines.length, 2) - 1) * lh / 2; // 3. wiersz dochodzi w dol
    var px = capH / 0.68;
    ctx.save(); ctx.fillStyle = color; ctx.textAlign = 'center';
    lines.forEach(function (l) { px = Math.min(px, fit(ctx, l, 400, px, fam, t.w * g.S, 0)); });
    ctx.font = font(400, px, fam);
    lines.forEach(function (l, k) { ctx.fillText(l, g.X(t.cx), y0 + k * lh + Math.min(capH, px * 0.68) / 2); });
    ctx.restore();
  }
  function dzCustom(st, d) { // napis lub kolor zmieniony -> wersja pliku bez napisu
    var txt = d.text == null ? DZDEF[st] : String(d.text);
    return !!DZDEF[st] && (normT(txt) !== normT(DZDEF[st]) || !!TXTC[d.textColor]) && gsHas(GSDZ[st] + 'b');
  }
  function gsAspect(id, def) { var m = (global.KCApparelGS || {})[id]; m = m && (m.light || m.dark); return m ? m.H / m.W : def; }
  T.dziecinstwo = {
    id: 'dziecinstwo', name: 'Zdjęcia z dzieciństwa', w: 28, h: 26,
    fonts: ['Caveat', 'Great Vibes', 'Special Elite', 'Mynerve', 'Allison', 'Sacramento', 'Kaushan Script', 'Nothing You Could Do', 'Hanken Grotesk'],
    styles: { inicjaly: 'Polaroidy z inicjałami', podpis: 'I love you', finding: 'Finding you…', forever2: 'Forever Young (2 zdjęcia)', forever: 'Jeden polaroid', walentynki: 'Zdjęcia z napisem' },
    dims: function (d) {
      var st = d.style || 'inicjaly', id = GSDZ[st];
      if (id && gsHas(id)) { if (dzCustom(st, d)) id += 'b'; var w = st === 'forever' ? 20 : 28; return { w: w, h: w * gsAspect(id, 1) }; }
      if (st === 'forever') return { w: 20, h: 26 };
      if (st === 'walentynki') return { w: 28, h: 26 };
      if (st === 'podpis') return { w: 28, h: 28 * gsAspect('dzpodpis', 0.84) };
      return { w: 28, h: 20 };
    },
    draw: function (ctx, W, H, d) {
      var u = W / 100, st = d.style || 'inicjaly', ph = d.photos || [], q = d._q = [], pen = FRAME === 'czarny' ? '#EFEAE0' : '#2A2420', D = this.dims(d);
      // filtr vintage: domyslnie wylaczony w I love you i Forever Young (oryginalne zdjecia), w pozostalych wlaczony
      var vint = d.vintage != null ? !!d.vintage : !({ podpis: 1, forever2: 1, forever: 1 })[st];
      // greenscreeny usera (vintage kartki); zdjecia w tonie vintage z rysami; teksty klienta wpisywane w miejsce wymazanych
      // napis/kolor zmieniony -> wersja pliku BEZ napisu ('b') + napis czcionka; bez zmian -> oryginal 1:1
      var col = TXTC[d.textColor], txt = d.text == null ? DZDEF[st] : String(d.text), custom = dzCustom(st, d);
      var gid = GSDZ[st] && (custom ? GSDZ[st] + 'b' : GSDZ[st]), g = gid && gsDraw({ id: gid, w: D.w, h: D.h }, ctx, W, H, d, vint ? VINTAGE : null, vint);
      if (g && custom) {
        var defc = st === 'finding' ? (d.dark ? '#FFFFFF' : '#111111') : (st === 'forever2' ? '#3E3832' : '#1C1A1A');
        gsTextBlock(ctx, g, 0, txt, DZFONT[st], col || defc, { podpis: 1.5, forever2: 1.35, finding: 1 }[st]); // pisma odreczne maja niskie litery
        return;
      }
      if (g) {
        if (st === 'inicjaly') {
          var i2 = splitInitials(d), ini = [i2[0], i2[1]].filter(Boolean).join('+');
          gsText(ctx, g, 0, ini.toUpperCase(), 'Mynerve', 400, col || (FRAME === 'czarny' ? '#EFEAE0' : '#1E1B1A'), 0.035);
        }
        if (st === 'forever') {
          gsText(ctx, g, 0, String(d.text == null ? 'FOREVER YOUNG' : d.text).toUpperCase(), 'Special Elite', 400, col || (FRAME === 'czarny' ? '#EFEAE0' : '#473A2A'));
          gsText(ctx, g, 1, String(d.year == null ? '1976' : d.year), 'Special Elite', 400, col || (FRAME === 'czarny' ? '#EFEAE0' : '#473A2A'));
        }
        return;
      }
      if (st === 'forever') {
        var t = (d.text || 'FOREVER YOUNG').toUpperCase();
        polaroid(ctx, ph[0], W / 2, H / 2, 86 * u, -1.5, 0, q, D.w, W, H, D.h, 1, function (x, cw, ch, bot) {
          x.fillStyle = pen; fit(x, t, 400, cw * 0.075, 'Special Elite', cw * 0.84, 0.06);
          textAt(x, t, cw / 2, ch - bot * 0.4, 0.06, 'center');
        });
        return;
      }
      if (st === 'walentynki') { // user 09.10: vintage jak polaroidy - 2 cz-b odbitki z waska ramka, duzy odreczny napis na zdjeciach
        var pw = 47 * u, PR = { r: 1.3, side: 0.045, bot: 0.045, plain: !vint };
        polaroid(ctx, ph[0], 27 * u, 33 * u, pw, -3, 1, q, D.w, W, H, D.h, 1, null, PR);
        polaroid(ctx, ph[1], 73 * u, 42 * u, pw, 2.5, 2, q, D.w, W, H, D.h, 2, null, PR);
        var vt = String(d.text == null ? "Happy Valentine's Day" : d.text).trim(), lines;
        if (vt.indexOf('|') >= 0) lines = vt.split('|').map(function (x) { return x.trim(); });
        else { var ws = vt.split(/\s+/); lines = ws.length >= 3 ? [ws[0], ws.slice(1, -1).join(' '), ws[ws.length - 1]] : ws; }
        ctx.save(); ctx.fillStyle = col || '#C8102E'; ctx.textAlign = 'center'; ctx.translate(50 * u, 52 * u); ctx.rotate(-7 * Math.PI / 180);
        var fs = 16 * u;
        lines.forEach(function (l) { fs = Math.min(fs, fit(ctx, l, 400, fs, 'Nothing You Could Do', 74 * u, 0)); });
        ctx.font = font(400, fs, 'Nothing You Could Do');
        lines.forEach(function (l, i) { ctx.fillText(l, (i - (lines.length - 1) / 2) * 4 * u, i * fs * 0.95); });
        ctx.restore();
        return;
      }
      // inicjaly (i zapas dla podpisu bez pliku): 2 vintage polaroidy zachodzace na siebie, inicjal na kazdej ramce
      var pw2 = 49 * u, cy = H / 2, dx = pw2 * 0.47, ii = splitInitials(d);
      var parts = st === 'inicjaly' ? [ii[0] ? ii[0] + '.' : '', ii[1] ? ii[1] + '.' : ''] : ['', ''];
      function writer(txt) {
        return function (x, cw, ch, bot) {
          if (!txt) return;
          x.fillStyle = pen; x.textAlign = 'center'; x.font = font(500, bot * 0.62, 'Caveat'); x.fillText(txt, cw / 2, ch - bot * 0.3);
        };
      }
      polaroid(ctx, ph[0], W / 2 - dx, cy + 1.2 * u, pw2, -7, 1, q, D.w, W, H, D.h, 1, writer(parts[0]));
      var r2 = polaroid(ctx, ph[1], W / 2 + dx, cy - 0.6 * u, pw2, 5, 2, q, D.w, W, H, D.h, 2, writer(parts[1]));
      if (st === 'inicjaly') heartPlus(ctx, W / 2, cy + r2.h / 2 - r2.bot * 0.55, r2.bot * 0.42, pen);
    }
  };
  T.zdjecie = T.dziecinstwo;

  // N7 — Tata i corka: TATA + "i córka" + ilustracja (plik B) + data + Best Friends For Life
  var LINEART = null;
  T.tatacorka = {
    id: 'tatacorka', name: 'Tata i córka', w: 26, h: 30,
    fonts: ['Playfair Display', 'Great Vibes', 'Hanken Grotesk'],
    draw: function (ctx, W, H, d) {
      var u = W / 100, ink = d.ink, cx = W / 2;
      ctx.fillStyle = ink; ctx.textBaseline = 'alphabetic';
      var top = (d.top || 'TATA').toUpperCase(), artKey = (/^MAM/.test(top) ? 'mama' : 'tata') + '-' + (/syn/i.test(d.sub || '') ? 'syn' : 'corka');
      fit(ctx, top, 500, 22 * u, 'Playfair Display', W * 0.8, 0.04); textAt(ctx, top, cx, 20 * u, 0.04, 'center');
      fit(ctx, d.sub || 'i córka', 400, 12 * u, 'Great Vibes', W * 0.6, 0); ctx.textAlign = 'center'; ctx.fillText(d.sub || 'i córka', cx, 31 * u);
      var art = global.KCApparelArt && (global.KCApparelArt[artKey] || global.KCApparelArt.tatacorka);
      if (art && art.complete && art.naturalWidth) {
        var ac = document.createElement('canvas'); ac.width = art.naturalWidth; ac.height = art.naturalHeight;
        var ax = ac.getContext('2d'); ax.drawImage(art, 0, 0); ax.globalCompositeOperation = 'source-in'; ax.fillStyle = ink; ax.fillRect(0, 0, ac.width, ac.height);
        drawContain(ctx, ac, W * 0.16, 35 * u, W * 0.68, 64 * u, 'center');
      } else {
        heart(ctx, cx, 64 * u, 16 * u, hexA(ink, 0.5));
      }
      var yr = yearOf(d.date);
      if (yr) { ctx.font = font(500, 3 * u, 'Hanken Grotesk'); textAt(ctx, 'EST. ' + yr, W - 8 * u, 40 * u, 0.15, 'right'); }
      ctx.font = font(400, 6.4 * u, 'Great Vibes'); ctx.textAlign = 'center'; ctx.fillText(d.line || 'Best Friends For Life', cx, H - 2 * u);
    }
  };

  // N8 — DAD (AI po zamowieniu): litery wypelnione zdjeciami, EST. data
  T.dad = {
    id: 'dad', name: 'DAD – portret ze zdjęcia (AI)', w: 30, h: 22, ai: true,
    fonts: ['Archivo Black', 'Playfair Display'],
    draw: function (ctx, W, H, d) {
      var u = W / 100, ink = d.ink, word = (d.word || 'DAD').toUpperCase().slice(0, 8), ph = d.photos || [];
      var size = fit(ctx, word, 400, 70 * u, 'Archivo Black', W * 0.98, -0.02), base = size * 0.78;
      ctx.font = font(400, size, 'Archivo Black');
      var chars = Array.from(word), ws = chars.map(function (c) { return ctx.measureText(c).width; }), gap = -0.02 * size;
      var tot = ws.reduce(function (a, b) { return a + b; }, 0) + gap * (chars.length - 1), x = (W - tot) / 2, top = base - size * 0.74;
      var perLetter = ph.filter(function (p) { return p && p.img; }).length >= chars.length && chars.length > 1;
      d._q = [];
      chars.forEach(function (ch, i) {
        var p = perLetter ? ph[i] : ph[0];
        ctx.save(); ctx.beginPath();
        ctx.font = font(400, size, 'Archivo Black');
        // clip do ksztaltu litery: rysujemy litere na osobnym canvasie jako maske
        var m = document.createElement('canvas'); m.width = Math.ceil(ws[i] + 4); m.height = Math.ceil(size); var mx = m.getContext('2d');
        mx.font = ctx.font; mx.fillStyle = '#000'; mx.textBaseline = 'alphabetic'; mx.fillText(ch, 2, base - top);
        var lay = document.createElement('canvas'); lay.width = m.width; lay.height = m.height; var lx = lay.getContext('2d');
        if (p && p.img) {
          if (perLetter) drawPhoto(lx, p, 0, 0, lay.width, lay.height);
          else drawPhoto(lx, p, -(x - (W - tot) / 2), 0, tot, lay.height); // jedno zdjecie przez wszystkie litery
          if (perLetter || i === 0) d._q.push({ ph: p, wCm: (perLetter ? ws[i] : tot) / W * 30, hCm: size / H * 22 });
        } else { lx.fillStyle = hexA(ink, 0.18); lx.fillRect(0, 0, lay.width, lay.height); }
        lx.globalCompositeOperation = 'destination-in'; lx.drawImage(m, 0, 0);
        ctx.drawImage(lay, x - 2, top);
        ctx.restore();
        // obrys litery
        ctx.save(); ctx.font = font(400, size, 'Archivo Black'); ctx.lineJoin = 'round'; ctx.lineWidth = size * 0.03; ctx.strokeStyle = ink;
        ctx.textAlign = 'left'; ctx.strokeText(ch, x, base); ctx.restore();
        x += ws[i] + gap;
      });
      if (!(ph[0] && ph[0].img)) { ctx.fillStyle = hexA(ink, 0.6); ctx.font = font(600, 3 * u, 'Hanken Grotesk'); ctx.textAlign = 'center'; ctx.fillText('Tu pojawią się Twoje zdjęcia', W / 2, base - size * 0.3); }
      var yr = d.date ? (/^\s*(est|since)/i.test(d.date) ? d.date.toUpperCase() : 'EST. ' + yearOf(d.date)) : '';
      if (yr) { ctx.fillStyle = ink; fit(ctx, yr, 500, 8 * u, 'Playfair Display', W * 0.5, 0.08); textAt(ctx, yr, W / 2, H - 1 * u, 0.08, 'center'); }
    }
  };

  // N9 — Wlasny nadruk: wgrana grafika (contain), opcjonalny tekst nad/pod
  // LOVE (user 09.10, wzor z Canvy): L + serce / V + E wypelnione zdjeciami, odreczne slowo w poprzek, imiona i data pod spodem
  function heartBox(c, x, y, w, h) {
    c.beginPath(); c.moveTo(x + w / 2, y + h);
    c.bezierCurveTo(x + w * 0.1, y + h * 0.72, x - w * 0.02, y + h * 0.42, x + w * 0.02, y + h * 0.25);
    c.bezierCurveTo(x + w * 0.08, y - h * 0.02, x + w * 0.42, y - h * 0.04, x + w / 2, y + h * 0.22);
    c.bezierCurveTo(x + w * 0.58, y - h * 0.04, x + w * 0.92, y - h * 0.02, x + w * 0.98, y + h * 0.25);
    c.bezierCurveTo(x + w * 1.02, y + h * 0.42, x + w * 0.9, y + h * 0.72, x + w / 2, y + h); c.closePath();
  }
  // zdjecie (albo pusty slot) przyciete do ksztaltu: litera rozciagnieta na cale pole albo serce
  function shapePhoto(ctx, ph, x, y, w, h, shape, n, ink, q, W, H, Wcm, Hcm) {
    var c = document.createElement('canvas'); c.width = Math.max(1, Math.ceil(w)); c.height = Math.max(1, Math.ceil(h));
    var cx = c.getContext('2d');
    if (ph && ph.img) { drawPhoto(cx, ph, 0, 0, c.width, c.height); q.push({ ph: ph, wCm: w / W * Wcm, hCm: h / H * Hcm }); }
    else {
      cx.fillStyle = hexA(ink, 0.16); cx.fillRect(0, 0, c.width, c.height);
      cx.fillStyle = hexA(ink, 0.6); cx.font = font(600, Math.min(c.width, c.height) * 0.11, 'Hanken Grotesk');
      cx.textAlign = 'center'; cx.textBaseline = 'middle'; cx.fillText('Zdjęcie ' + n, c.width / 2, c.height * 0.55);
    }
    cx.globalCompositeOperation = 'destination-in'; cx.fillStyle = '#000';
    if (shape === '♥') { heartBox(cx, 0, 0, c.width, c.height); cx.fill(); }
    else {
      var px = c.height / 0.72; cx.font = font(400, px, 'Archivo Black'); cx.textBaseline = 'alphabetic'; cx.textAlign = 'left';
      var m = cx.measureText(shape), lw = (m.actualBoundingBoxRight || m.width) + (m.actualBoundingBoxLeft || 0);
      cx.save(); cx.scale(c.width / lw, 1); cx.fillText(shape, m.actualBoundingBoxLeft || 0, c.height); cx.restore();
    }
    ctx.drawImage(c, x, y, w, h);
  }
  T.love = {
    id: 'love', name: 'LOVE – zdjęcia w literach', w: 28, h: 33,
    fonts: ['Archivo Black', 'Great Vibes', 'Playfair Display', 'Hanken Grotesk'],
    draw: function (ctx, W, H, d) {
      var u = W / 100, ph = d.photos || [], q = d._q = [], ink = d.ink, g = ({ brak: 0.6, waskie: 2.5, szerokie: 4.5 })[d.gap || 'waskie'] * u, rh = 42 * u;
      var cells = [
        { s: 'L', x: 0, y: 0, w: 36 * u },
        { s: '♥', x: 36 * u + g, y: 2 * u, w: 100 * u - 36 * u - g, h: rh - 2 * u },
        { s: 'V', x: 0, y: rh + g, w: 50 * u - g / 2 },
        { s: 'E', x: 50 * u + g / 2, y: rh + g, w: 50 * u - g / 2 }
      ];
      var self = this;
      cells.forEach(function (c, i) { shapePhoto(ctx, ph[i], c.x, c.y, c.w, c.h || rh, c.s, i + 1, ink, q, W, H, self.w, self.h); });
      // odreczne slowo w poprzek (na styku wierszy, od lewej)
      var word = d.word == null ? 'Moment' : d.word;
      if (word) {
        ctx.save(); ctx.fillStyle = ink; ctx.translate(4 * u, rh + 5 * u); ctx.rotate(-8 * Math.PI / 180);
        fit(ctx, word, 400, 17 * u, 'Great Vibes', 62 * u, 0); ctx.textAlign = 'left'; ctx.fillText(word, 0, 0); ctx.restore();
      }
      ctx.fillStyle = ink; ctx.textAlign = 'center';
      var yb = 2 * rh + g;
      if (d.names) { fit(ctx, d.names, 700, 5.2 * u, 'Playfair Display', 90 * u, 0.01); textAt(ctx, d.names, W / 2, yb + 7.5 * u, 0.01, 'center'); }
      if (d.date) { ctx.font = font(700, 4.2 * u, 'Playfair Display'); textAt(ctx, d.date, W / 2, yb + 13 * u, 0.02, 'center'); }
    }
  };

  // Piosenka / odtwarzacz (user 09.10, Canva "Music Player 5x7"): zdjecie + tytul, wykonawca, pasek, przyciski.
  // Style: kwadrat (zdjecie w ramce, pelne ikony), kolo (okragle zdjecie z obwodka, ikony w kolkach), plyta (krazek z dziura, duzy play).
  function secs(t) { var m = String(t || '').match(/(\d+)\s*[:.]\s*(\d{1,2})/); return m ? +m[1] * 60 + +m[2] : 0; }
  function mpIcon(c, kind, x, y, s, ink, outline) {
    c.save(); c.translate(x, y); c.fillStyle = ink; c.strokeStyle = ink; c.lineWidth = s * 0.11; c.lineJoin = 'round'; c.lineCap = 'round';
    function tri(x0, dir, w, h, fill) { c.beginPath(); c.moveTo(x0, -h / 2); c.lineTo(x0 + dir * w, 0); c.lineTo(x0, h / 2); c.closePath(); if (fill) c.fill(); else c.stroke(); }
    var f = !outline;
    if (kind === 'play') tri(-s * 0.32, 1, s * 0.75, s * 0.85, true);
    else if (kind === 'pause') { c.fillRect(-s * 0.28, -s * 0.38, s * 0.18, s * 0.76); c.fillRect(s * 0.1, -s * 0.38, s * 0.18, s * 0.76); }
    else if (kind === 'ff') { tri(-s * 0.5, 1, s * 0.5, s * 0.6, f); tri(0, 1, s * 0.5, s * 0.6, f); }
    else if (kind === 'rw') { tri(s * 0.5, -1, s * 0.5, s * 0.6, f); tri(0, -1, s * 0.5, s * 0.6, f); }
    else if (kind === 'next') { tri(-s * 0.35, 1, s * 0.5, s * 0.62, f); c.fillRect(s * 0.18, -s * 0.31, s * 0.12, s * 0.62); }
    else if (kind === 'prev') { tri(s * 0.35, -1, s * 0.5, s * 0.62, f); c.fillRect(-s * 0.3, -s * 0.31, s * 0.12, s * 0.62); }
    else if (kind === 'shuffle') {
      c.beginPath(); c.moveTo(-s * 0.45, -s * 0.25); c.bezierCurveTo(-s * 0.05, -s * 0.25, s * 0.05, s * 0.25, s * 0.38, s * 0.25);
      c.moveTo(-s * 0.45, s * 0.25); c.bezierCurveTo(-s * 0.05, s * 0.25, s * 0.05, -s * 0.25, s * 0.38, -s * 0.25); c.stroke();
      [-1, 1].forEach(function (k) { c.beginPath(); c.moveTo(s * 0.3, k * s * 0.25 - s * 0.12); c.lineTo(s * 0.46, k * s * 0.25); c.lineTo(s * 0.3, k * s * 0.25 + s * 0.12); c.stroke(); });
    }
    else if (kind === 'repeat') {
      c.beginPath(); c.moveTo(-s * 0.3, s * 0.05); c.lineTo(-s * 0.3, -s * 0.2); c.lineTo(s * 0.35, -s * 0.2);
      c.moveTo(s * 0.3, -s * 0.05); c.lineTo(s * 0.3, s * 0.2); c.lineTo(-s * 0.35, s * 0.2); c.stroke();
      c.beginPath(); c.moveTo(s * 0.22, -s * 0.32); c.lineTo(s * 0.38, -s * 0.2); c.lineTo(s * 0.22, -s * 0.08); c.stroke();
      c.beginPath(); c.moveTo(-s * 0.22, s * 0.32); c.lineTo(-s * 0.38, s * 0.2); c.lineTo(-s * 0.22, s * 0.08); c.stroke();
    }
    c.restore();
  }
  T.muzyka = {
    id: 'muzyka', name: 'Piosenka – odtwarzacz ze zdjęciem', w: 24, h: 33.6,
    fonts: ['Raleway', 'Hanken Grotesk'],
    draw: function (ctx, W, H, d) {
      var u = W / 100, ink = d.ink, st = d.style || 'kwadrat', ph = d.photos || [], q = d._q = [];
      var title = d.song == null ? 'Song Name' : d.song, artist = d.artist == null ? 'Artist name' : d.artist;
      var t1 = d.t1 == null ? '1:35' : d.t1, t2 = d.t2 == null ? '5:45' : d.t2, prog = Math.max(0.02, Math.min(0.98, secs(t1) / (secs(t2) || 1) || 0.3));
      ctx.fillStyle = ink; ctx.strokeStyle = ink;
      if (st === 'kwadrat') {
        ctx.lineWidth = 0.35 * u; ctx.strokeRect(8 * u, 5 * u, 84 * u, 84 * u);
        photoOr(ctx, ph[0], 9.2 * u, 6.2 * u, 81.6 * u, 81.6 * u, 1, ink);
        if (ph[0] && ph[0].img) q.push({ ph: ph[0], wCm: 0.816 * this.w, hCm: 0.816 * this.w });
      } else {
        var R = 42 * u, cx = 50 * u, cy = 47 * u, c = document.createElement('canvas'); c.width = c.height = Math.ceil(2 * R);
        var x = c.getContext('2d');
        if (ph[0] && ph[0].img) { drawPhoto(x, ph[0], 0, 0, c.width, c.height); q.push({ ph: ph[0], wCm: 0.84 * this.w, hCm: 0.84 * this.w }); }
        else { x.fillStyle = hexA(ink, 0.16); x.fillRect(0, 0, c.width, c.height); x.fillStyle = hexA(ink, 0.6); x.font = font(600, R * 0.16, 'Hanken Grotesk'); x.textAlign = 'center'; x.textBaseline = 'middle'; x.fillText('Zdjęcie', R, R * 0.7); }
        x.globalCompositeOperation = 'destination-in'; x.beginPath(); x.arc(R, R, R, 0, Math.PI * 2);
        if (st === 'plyta') x.arc(R, R, R * 0.15, 0, Math.PI * 2, true); // dziura w plycie
        x.fill();
        ctx.drawImage(c, cx - R, cy - R, 2 * R, 2 * R);
        if (st === 'kolo') { ctx.lineWidth = 0.35 * u; ctx.beginPath(); ctx.arc(cx, cy, R + 1.6 * u, 0, Math.PI * 2); ctx.stroke(); }
      }
      if (st === 'plyta') { // tytul na srodku, serce z lewej, cienki pasek z kreska
        ctx.textAlign = 'center'; fit(ctx, title, 700, 5 * u, 'Raleway', 66 * u, 0); ctx.fillText(title, 50 * u, 98 * u);
        ctx.font = font(400, 3.4 * u, 'Raleway'); ctx.fillText(artist, 50 * u, 104 * u);
        heart(ctx, 8 * u, 97 * u, 5 * u, ink);
        ctx.fillRect(8 * u, 112.4 * u, 84 * u, 0.8 * u); ctx.fillRect(8 * u + 84 * u * prog - 0.6 * u, 110.3 * u, 1.2 * u, 5 * u);
        ctx.font = font(400, 2.4 * u, 'Raleway'); ctx.textAlign = 'left'; ctx.fillText(t1, 8 * u, 118.5 * u); ctx.textAlign = 'right'; ctx.fillText(t2, 92 * u, 118.5 * u);
        var yc = 128 * u;
        mpIcon(ctx, 'shuffle', 10 * u, yc, 7 * u, ink); mpIcon(ctx, 'prev', 24 * u, yc, 6 * u, ink, true); mpIcon(ctx, 'rw', 37 * u, yc, 7.5 * u, ink, true);
        mpIcon(ctx, 'play', 51 * u, yc, 11 * u, ink); mpIcon(ctx, 'ff', 65 * u, yc, 7.5 * u, ink, true); mpIcon(ctx, 'next', 78 * u, yc, 6 * u, ink, true); mpIcon(ctx, 'repeat', 91 * u, yc, 7 * u, ink);
        return;
      }
      // kwadrat / kolo: tytul z lewej, fala dzwieku z prawej, serce, gruby pasek z kropka
      ctx.textAlign = 'left'; fit(ctx, title, 700, 5 * u, 'Raleway', 54 * u, 0); ctx.fillText(title, 8 * u, 101 * u);
      ctx.font = font(400, 3.4 * u, 'Raleway'); fit(ctx, artist, 400, 3.4 * u, 'Raleway', 54 * u, 0); ctx.fillText(artist, 8 * u, 107.5 * u);
      var bars = [0.35, 0.6, 0.3, 0.8, 0.5, 0.95, 0.4, 0.7, 0.3, 0.55, 1, 0.45, 0.75, 0.35, 0.6, 0.3];
      bars.forEach(function (b, i) { var hh = 8 * u * b; ctx.fillRect(66 * u + i * 1.65 * u, 99 * u - hh / 2, 0.75 * u, hh); });
      heart(ctx, 90 * u, 113.5 * u, 4.4 * u, ink);
      ctx.fillRect(8 * u, 117.2 * u, 84 * u, 1.3 * u); ctx.beginPath(); ctx.arc(8 * u + 84 * u * prog, 117.85 * u, 2.4 * u, 0, Math.PI * 2); ctx.fill();
      ctx.font = font(400, 2.4 * u, 'Raleway'); ctx.textAlign = 'left'; ctx.fillText(t1, 8 * u, 123 * u); ctx.textAlign = 'right'; ctx.fillText(t2, 92 * u, 123 * u);
      var y2 = 131 * u, xs = [11, 30, 43, 56, 69, 82, 92].map(function (v) { return v * u; });
      if (st === 'kolo') {
        xs = [11, 26, 38.5, 51, 63.5, 76, 90].map(function (v) { return v * u; });
        ctx.lineWidth = 0.4 * u; xs.forEach(function (xx) { ctx.beginPath(); ctx.arc(xx, y2, 4.2 * u, 0, Math.PI * 2); ctx.stroke(); });
        ['shuffle', 'prev', 'rw', 'pause', 'ff', 'next', 'repeat'].forEach(function (k, i) { mpIcon(ctx, k, xs[i], y2, 4.4 * u, ink, true); });
      } else {
        ['shuffle', 'prev', 'rw', 'playc', 'ff', 'next', 'repeat'].forEach(function (k, i) {
          if (k === 'playc') { ctx.lineWidth = 0.45 * u; ctx.beginPath(); ctx.arc(xs[i], y2, 3.2 * u, 0, Math.PI * 2); ctx.stroke(); mpIcon(ctx, 'play', xs[i] + 0.3 * u, y2, 3.2 * u, ink); }
          else mpIcon(ctx, k, xs[i], y2, k === 'rw' || k === 'ff' ? 7.5 * u : 6.5 * u, ink);
        });
      }
    }
  };

  T.wlasny = {
    id: 'wlasny', name: 'Własny nadruk', w: 28, h: 35,
    fonts: ['Anton', 'Bebas Neue', 'Montserrat', 'Oswald', 'Pacifico', 'Playfair Display', 'Roboto Slab', 'Ruslan Display'],
    draw: function (ctx, W, H, d) {
      var u = W / 100, ph = (d.photos || [])[0], t = d.text || '', fam = d.font || 'Montserrat', pos = d.textPos || 'Pod wzorem';
      var tH = t && pos !== 'Na plecach' ? 14 * u : 0, above = /nad/i.test(pos);
      var gy = above ? tH : 0, gh = H - tH;
      if (ph && ph.img) {
        var src = d.removeBg && ph.cut ? ph.cut : ph.img;
        var z = ph.zoom || 1, bw = W * z, bh = gh * z;
        var r = drawContain(ctx, src, (W - bw) / 2 + (ph.ox || 0) * W * 0.3, gy + (gh - bh) / 2 + (ph.oy || 0) * gh * 0.3, bw, bh, 'center');
        d._q = [{ ph: ph, wCm: r.w / W * this.w, hCm: r.h / H * this.h }];
      } else slot(ctx, W * 0.1, gy + gh * 0.1, W * 0.8, gh * 0.8, 0, d.ink);
      if (tH) {
        ctx.fillStyle = d.textColor || d.ink; fit(ctx, t, 600, 10 * u, fam, W * 0.95, 0);
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText(t, W / 2, above ? tH / 2 : H - tH / 2); ctx.textBaseline = 'alphabetic';
      }
    }
  };

  // ================= UBRANIA (zastepcze, rysowane) — podmieniane na zdjecia B (KCApparel.setGarmentImages) =================
  // Uklad wspolrzednych: kadr 100 x 100 j. (1 j. ~ 1 cm dla rozmiaru L). Pola nadruku w tych jednostkach.
  var AREAS = {
    tee: { chest: { x: 36, y: 22, w: 28, h: 35 }, left: { x: 56.5, y: 23, w: 9, h: 9 }, right: { x: 34.5, y: 23, w: 9, h: 9 }, back: { x: 35, y: 21, w: 30, h: 40 } },
    crew: { chest: { x: 36, y: 22, w: 28, h: 30 }, left: { x: 56.5, y: 23, w: 9, h: 9 }, right: { x: 34.5, y: 23, w: 9, h: 9 }, back: { x: 35, y: 21, w: 30, h: 40 } },
    hoodie: { chest: { x: 36, y: 25, w: 28, h: 26 }, left: { x: 56.5, y: 26, w: 9, h: 9 }, right: { x: 34.5, y: 26, w: 9, h: 9 }, back: { x: 35, y: 24, w: 30, h: 38 } }
  };
  var GARMENT_IMG = {}; // { 'tee-front': {img, mask?, areas?, ppc?} }

  function shapeTee(c, k, back) {
    c.beginPath();
    c.moveTo(41 * k, 12 * k); // lewy brzeg kolnierza
    if (back) c.quadraticCurveTo(50 * k, 14.5 * k, 59 * k, 12 * k);
    else c.quadraticCurveTo(50 * k, 20 * k, 59 * k, 12 * k);
    c.lineTo(72 * k, 15 * k); c.lineTo(91 * k, 27 * k); c.lineTo(84 * k, 38 * k); c.lineTo(77 * k, 34 * k);
    c.lineTo(77.5 * k, 90 * k); c.quadraticCurveTo(50 * k, 92 * k, 22.5 * k, 90 * k);
    c.lineTo(23 * k, 34 * k); c.lineTo(16 * k, 38 * k); c.lineTo(9 * k, 27 * k); c.lineTo(28 * k, 15 * k); c.closePath();
  }
  function shapeLong(c, k, back, hood) {
    c.beginPath();
    c.moveTo(41 * k, 13 * k);
    if (back || hood) c.quadraticCurveTo(50 * k, 15 * k, 59 * k, 13 * k); else c.quadraticCurveTo(50 * k, 19 * k, 59 * k, 13 * k);
    c.lineTo(72 * k, 16 * k); c.quadraticCurveTo(80 * k, 18 * k, 83 * k, 30 * k); c.lineTo(93 * k, 82 * k); c.lineTo(84 * k, 85 * k); c.lineTo(77.5 * k, 44 * k);
    c.lineTo(77.5 * k, 86 * k); c.lineTo(78 * k, 92 * k); c.quadraticCurveTo(50 * k, 94 * k, 22 * k, 92 * k); c.lineTo(22.5 * k, 86 * k);
    c.lineTo(22.5 * k, 44 * k); c.lineTo(16 * k, 85 * k); c.lineTo(7 * k, 82 * k); c.lineTo(17 * k, 30 * k); c.quadraticCurveTo(20 * k, 18 * k, 28 * k, 16 * k); c.closePath();
  }
  function drawGarmentVector(ctx, S, type, side, hex) {
    var k = S / 100, back = side === 'back', dark = isDark(hex);
    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,0.25)'; ctx.shadowBlur = 2.2 * k; ctx.shadowOffsetY = 0.8 * k;
    ctx.fillStyle = hex;
    if (type === 'tee') shapeTee(ctx, k, back); else shapeLong(ctx, k, back, type === 'hoodie');
    ctx.fill(); ctx.restore();
    // cieniowanie
    ctx.save();
    if (type === 'tee') shapeTee(ctx, k, back); else shapeLong(ctx, k, back, type === 'hoodie');
    ctx.clip();
    var g = ctx.createLinearGradient(0, 0, S, 0);
    g.addColorStop(0, 'rgba(0,0,0,0.16)'); g.addColorStop(0.22, 'rgba(0,0,0,0.02)'); g.addColorStop(0.5, 'rgba(255,255,255,0.05)');
    g.addColorStop(0.78, 'rgba(0,0,0,0.02)'); g.addColorStop(1, 'rgba(0,0,0,0.16)');
    ctx.fillStyle = g; ctx.fillRect(0, 0, S, S);
    ctx.strokeStyle = dark ? 'rgba(255,255,255,0.07)' : 'rgba(0,0,0,0.07)'; ctx.lineWidth = 0.5 * k; ctx.lineCap = 'round';
    [[30, 60, 34, 85], [70, 55, 66, 86], [45, 70, 47, 88]].forEach(function (l) { ctx.beginPath(); ctx.moveTo(l[0] * k, l[1] * k); ctx.quadraticCurveTo((l[0] + 2) * k, (l[1] + l[3]) / 2 * k, l[2] * k, l[3] * k); ctx.stroke(); });
    // sciegi: rekawy, dol
    ctx.strokeStyle = dark ? 'rgba(255,255,255,0.10)' : 'rgba(0,0,0,0.12)'; ctx.setLineDash([0.6 * k, 0.6 * k]); ctx.lineWidth = 0.25 * k;
    ctx.beginPath(); ctx.moveTo(23 * k, 87.6 * k); ctx.quadraticCurveTo(50 * k, 89.5 * k, 77 * k, 87.6 * k); ctx.stroke(); ctx.setLineDash([]);
    if (type !== 'tee') { // sciagacz dolu
      ctx.fillStyle = dark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.06)'; ctx.fillRect(22 * k, 86 * k, 56 * k, 8 * k);
    }
    if (type === 'hoodie' && !back) { // kieszen kangurka
      ctx.strokeStyle = dark ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.13)'; ctx.lineWidth = 0.35 * k;
      ctx.beginPath(); ctx.moveTo(33 * k, 84 * k); ctx.lineTo(36 * k, 62 * k); ctx.lineTo(64 * k, 62 * k); ctx.lineTo(67 * k, 84 * k); ctx.stroke();
    }
    ctx.restore();
    // kolnierz / kaptur
    ctx.save(); ctx.fillStyle = hex; ctx.strokeStyle = dark ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.15)'; ctx.lineWidth = 0.4 * k;
    if (type === 'hoodie') {
      ctx.beginPath();
      if (back) { ctx.moveTo(37 * k, 15 * k); ctx.quadraticCurveTo(35 * k, 2 * k, 50 * k, 2 * k); ctx.quadraticCurveTo(65 * k, 2 * k, 63 * k, 15 * k); ctx.quadraticCurveTo(50 * k, 22 * k, 37 * k, 15 * k); }
      else { ctx.moveTo(37 * k, 14 * k); ctx.quadraticCurveTo(36 * k, 4 * k, 50 * k, 4 * k); ctx.quadraticCurveTo(64 * k, 4 * k, 63 * k, 14 * k); ctx.lineTo(56 * k, 24 * k); ctx.lineTo(44 * k, 24 * k); ctx.closePath(); }
      ctx.fill(); ctx.stroke();
      if (!back) { ctx.fillStyle = 'rgba(0,0,0,0.28)'; ctx.beginPath(); ctx.moveTo(41 * k, 8 * k); ctx.quadraticCurveTo(50 * k, 5 * k, 59 * k, 8 * k); ctx.lineTo(55 * k, 22 * k); ctx.lineTo(45 * k, 22 * k); ctx.closePath(); ctx.fill();
        ctx.strokeStyle = dark ? 'rgba(255,255,255,0.5)' : 'rgba(255,255,255,0.9)'; ctx.lineWidth = 0.5 * k; ctx.beginPath(); ctx.moveTo(46 * k, 24 * k); ctx.lineTo(45.5 * k, 34 * k); ctx.moveTo(54 * k, 24 * k); ctx.lineTo(54.5 * k, 34 * k); ctx.stroke(); }
    } else {
      ctx.beginPath(); ctx.moveTo(41 * k, 12 * k);
      if (back) { ctx.quadraticCurveTo(50 * k, 14.5 * k, 59 * k, 12 * k); ctx.quadraticCurveTo(50 * k, 16.5 * k, 41 * k, 12 * k); }
      else { ctx.quadraticCurveTo(50 * k, 20 * k, 59 * k, 12 * k); ctx.quadraticCurveTo(50 * k, 22.5 * k, 41 * k, 12 * k); }
      ctx.fill(); ctx.stroke();
      if (!back) { ctx.fillStyle = 'rgba(0,0,0,0.22)'; ctx.beginPath(); ctx.moveTo(41.5 * k, 12.2 * k); ctx.quadraticCurveTo(50 * k, 19 * k, 58.5 * k, 12.2 * k); ctx.quadraticCurveTo(50 * k, 13.5 * k, 41.5 * k, 12.2 * k); ctx.fill(); }
    }
    ctx.restore();
  }

  // Zdjecie ubrania od B: bialy/jasny material -> kolor = kolor * luminancja (multiply) + odbicia
  function drawGarmentPhoto(ctx, S, G, hex) {
    var tmp = document.createElement('canvas'); tmp.width = S; tmp.height = S; var t = tmp.getContext('2d');
    t.drawImage(G.img, 0, 0, S, S);
    if (lum(hex) < 0.93) {
      var col = document.createElement('canvas'); col.width = S; col.height = S; var c = col.getContext('2d');
      c.drawImage(G.img, 0, 0, S, S); c.globalCompositeOperation = 'source-in'; c.fillStyle = hex; c.fillRect(0, 0, S, S);
      t.globalCompositeOperation = 'multiply'; t.drawImage(col, 0, 0);
      if (isDark(hex)) { t.globalCompositeOperation = 'screen'; t.globalAlpha = 0.10; t.drawImage(G.img, 0, 0, S, S); t.globalAlpha = 1; }
      t.globalCompositeOperation = 'destination-in'; t.drawImage(G.mask || G.img, 0, 0, S, S);
    }
    ctx.drawImage(tmp, 0, 0);
  }

  // ================= MOCKUPY B (zdjecia ubran, gotowe kolory) =================
  // mockupy.json (tor B): widoki koszulka|bluza|kaptur-przod|tyl, kolory -> plik webp, shade.webp, pola (ulamek x,y,w,h kadru)
  var MOCK = null, MOCK_BASE = '', IMG = {}, onImg = null;
  var TYPE_PL = { tee: 'koszulka', crew: 'bluza', hoodie: 'kaptur' };
  function slug(v) { return plain(v).split(/[\s-]/)[0]; }
  function img(url) {
    if (IMG[url]) return IMG[url];
    var R = global.KCApparelResolve;
    if (R) { var ru = R(url, function () { if (onImg) onImg(); }); if (ru === null) return null; if (ru) { var j = new Image(); j.onload = function () { if (onImg) onImg(); }; j.src = ru; IMG[url] = j; return j; } }
    var i = new Image(); i.crossOrigin = 'anonymous';
    i.onload = function () { if (onImg) onImg(); };
    i.src = url; IMG[url] = i; return i;
  }
  function ready(i) { return i && i.complete && i.naturalWidth > 0; }
  function img_(u) { return img(u); }
  function mockView(type, side) {
    if (!MOCK) return null;
    var v = MOCK.widoki[(TYPE_PL[type] || 'koszulka') + '-' + (side === 'back' ? 'tyl' : 'przod')];
    return v || null;
  }
  function mockFile(v, color) {
    var s = slug(color), keys = Object.keys(v.kolory);
    for (var i = 0; i < keys.length; i++) if (slug(keys[i]) === s) return v.kolory[keys[i]].plik;
    // kolor spoza listy (np. bordowa na bluzie): najblizszy wg nazwy, inaczej biala
    var alt = { bordowa: 'brazowa', brazowa: 'bordowa', military: 'zielona' }[s];
    for (var j = 0; j < keys.length; j++) if (slug(keys[j]) === alt) return v.kolory[keys[j]].plik;
    for (var k = 0; k < keys.length; k++) if (slug(keys[k]) === 'biala') return v.kolory[keys[k]].plik;
    return null;
  }
  function mockArea(v, place) { // ulamki kadru -> jednostki 0..100 (+ szerokosc pola w cm)
    var P = v.pola, p;
    if (place === 'back') p = P.tyl || P.przod;
    else if (place === 'left' || place === 'right') p = P.piers_lewa || P.przod;
    else p = P.przod || P.tyl;
    var f = p.ulamek;
    if (place === 'right') f = [1 - f[0] - f[2], f[1], f[2], f[3]];
    return { x: f[0] * 100, y: f[1] * 100, w: f[2] * 100, h: f[3] * 100, cmw: p.max_cm ? p.max_cm[0] : null };
  }

  // ================= RENDER =================
  function ensureFonts(tpl) {
    if (!global.document || !document.fonts) return Promise.resolve();
    return Promise.all((tpl.fonts || []).concat(['Hanken Grotesk']).map(function (f) {
      return Promise.all(['400', '500', '600', '700', '800'].map(function (w) { return document.fonts.load(w + ' 40px "' + f + '"').catch(function () {}); }));
    }));
  }
  function prep(d) { d = d || {}; d.garment = d.garment || COLORS.biala; d.dark = isDark(d.garment); d.ink = d.inkOverride || (d.dark ? '#FFFFFF' : '#151515'); return d; }

  // Sam wzor na przezroczystym canvasie (W px szerokosci; wysokosc z proporcji szablonu)
  function renderDesign(canvas, tplId, data) {
    var tpl = T[tplId], d = prep(data), ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    TONE = TONE_F.hasOwnProperty(d.tone) ? d.tone : null; FRAME = d.frame || 'vintage';
    try { ctx.save(); tpl.draw(ctx, canvas.width, canvas.height, d); ctx.restore(); } finally { TONE = null; FRAME = 'vintage'; }
    return d;
  }
  // wymiary wzoru w cm; szablon moze je zmieniac zaleznie od danych (np. styl "Jeden polaroid" jest wezszy)
  function dims(tplId, d) { var t = T[tplId]; if (!t) return null; return t.dims ? t.dims(d || {}) : { w: t.w, h: t.h }; }
  function designSize(tplId, wPx, data) { var t = dims(tplId, data); return { w: wPx, h: Math.round(wPx * t.h / t.w) }; }

  // Plik do druku: 300 DPI w cm szablonu (np. 30x40 cm -> 3543 x 4724 px)
  function renderPrint(tplId, data) {
    var t = dims(tplId, data), c = document.createElement('canvas');
    c.width = Math.round(t.w * CM); c.height = Math.round(t.h * CM);
    renderDesign(c, tplId, data);
    return c;
  }

  // Podglad: ubranie (typ tee/crew/hoodie, strona front/back) + wzor w polu nadruku (place: chest/left/right/back)
  function renderMock(canvas, opts) {
    var S = canvas.width, k = S / 100, ctx = canvas.getContext('2d');
    var hex = opts.hex || colorHex(opts.color), type = opts.type || 'tee', side = opts.place === 'back' ? 'back' : 'front';
    var G = GARMENT_IMG[type + '-' + side], V = mockView(type, side), gi = null, sh = null;
    if (V) { var fp = mockFile(V, opts.color || ''); gi = fp ? img(MOCK_BASE + fp) : null; sh = img(MOCK_BASE + V.shade); }
    // user 09.10: przy zmianie koloru NIE pokazywac starego/zastepczego ubrania -> czekamy na zdjecie (onImg przerysuje)
    if (V && (!ready(gi) || !ready(sh)) && canvas._kcaDrawn) return { pending: true };
    ctx.clearRect(0, 0, S, canvas.height);
    if (ready(gi)) {
      ctx.save();
      if (opts.shadow) { ctx.shadowColor = 'rgba(46,34,22,0.30)'; ctx.shadowBlur = S * 0.035; ctx.shadowOffsetY = S * 0.018; } // cien jak pod plakatem
      ctx.drawImage(gi, 0, 0, S, S); ctx.restore();
    }
    else if (G && G.img && G.img.complete && G.img.naturalWidth) drawGarmentPhoto(ctx, S, G, hex); else drawGarmentVector(ctx, S, type, side, hex);
    canvas._kcaDrawn = true;
    if (!opts.tpl) return { empty: true };
    var useMock = ready(gi), place = opts.place || 'chest';
    var A = useMock ? mockArea(V, place) : ((G && G.areas) || AREAS[type])[place], t = dims(opts.tpl, opts.data);
    var M = useMock ? mockArea(V, side === 'back' ? 'back' : 'chest') : AREAS[type][side === 'back' ? 'back' : 'chest'];
    var cpu = (A.cmw || A.w) / A.w; // cm na jednostke kadru
    // niewidoczna ramka (user 09.10): od kolnierza do kieszeni/pasa; klient przesuwa wzor tylko w niej
    // user 09.10 v2: "daj wiecej wyboru" -> kaptur przod do gornej krawedzi kieszeni, reszta prawie do sciagacza/dolu
    var FH = { tee: { front: 1.6, back: 1.55 }, crew: { front: 1.62, back: 1.6 }, hoodie: { front: 1.16, back: 1.25 } };
    var F = { x: M.x - M.w * 0.22, w: M.w * 1.44, y: M.y - M.h * 0.03 };
    F.h = M.h * ((FH[type] || FH.tee)[side] || 1.4);
    // rozmiar: dopasowany do pola nadruku x skala klienta, nie wiekszy niz ramka
    var sc = Math.min(A.w / t.w, A.h / t.h) * (opts.scale || 1);
    sc = Math.min(sc, F.w / t.w, F.h / t.h);
    var wU = t.w * sc, hU = t.h * sc;
    // pozycja domyslna: wysrodkowany w polu, nizej niz krawedz pola (przod ~12% wysokosci pola, plecy ~8%)
    var cx = A.x + A.w / 2, cy = (place === 'left' || place === 'right') ? A.y + A.h / 2 : A.y + A.h * (side === 'back' ? 0.08 : 0.12) + hU / 2;
    if (opts.pos) { cx += opts.pos.x || 0; cy += opts.pos.y || 0; }
    cx = Math.max(F.x + wU / 2, Math.min(F.x + F.w - wU / 2, cx));
    cy = Math.max(F.y + hU / 2, Math.min(F.y + F.h - hU / 2, cy));
    var dx = (cx - wU / 2) * k, dy = (cy - hU / 2) * k, dw = wU * k, dh = hU * k;
    var dc = document.createElement('canvas'); dc.width = Math.max(50, Math.round(dw * 2)); dc.height = Math.max(50, Math.round(dh * 2));
    var d = renderDesign(dc, opts.tpl, Object.assign({}, opts.data, { garment: hex }));
    // falldy materialu na nadruku (README B): wycinek shade.webp soft-light ~0.7, potem przywrocenie alfy wzoru
    if (ready(gi) && ready(sh)) {
      var sx = sh.naturalWidth / S, x2 = dc.getContext('2d');
      var keep = document.createElement('canvas'); keep.width = dc.width; keep.height = dc.height; keep.getContext('2d').drawImage(dc, 0, 0);
      x2.save(); x2.globalCompositeOperation = 'soft-light'; x2.globalAlpha = 0.7;
      x2.drawImage(sh, dx * sx, dy * sx, dw * sx, dh * sx, 0, 0, dc.width, dc.height); x2.restore();
      x2.save(); x2.globalCompositeOperation = 'destination-in'; x2.drawImage(keep, 0, 0); x2.restore();
    }
    ctx.save(); ctx.globalAlpha = 0.97; ctx.drawImage(dc, dx, dy, dw, dh); ctx.restore();
    var defCx = A.x + A.w / 2, defCy = (place === 'left' || place === 'right') ? A.y + A.h / 2 : A.y + A.h * (side === 'back' ? 0.08 : 0.12) + hU / 2;
    return { design: d, rect: { x: dx, y: dy, w: dw, h: dh }, frame: { x: F.x * k, y: F.y * k, w: F.w * k, h: F.h * k },
      unit: k, pos: { x: cx - defCx, y: cy - defCy }, cm: { w: wU * cpu, h: hU * cpu } };
  }

  // Sam wzor (user 09.10: "sam preview wzoru jako podglad"): plaski wzor na probce koloru ubrania, bez ubrania
  function renderFlat(canvas, opts) {
    var S = canvas.width, ctx = canvas.getContext('2d'), t = dims(opts.tpl, opts.data), hex = opts.hex || colorHex(opts.color);
    ctx.clearRect(0, 0, S, canvas.height);
    var m = S * 0.05, r = S * 0.03, cw = S - 2 * m;
    ctx.save(); ctx.shadowColor = 'rgba(46,34,22,0.25)'; ctx.shadowBlur = S * 0.03; ctx.shadowOffsetY = S * 0.012;
    ctx.fillStyle = hex; ctx.beginPath();
    if (ctx.roundRect) ctx.roundRect(m, m, cw, cw, r); else ctx.rect(m, m, cw, cw);
    ctx.fill(); ctx.restore();
    if (lum(hex) > 0.93) { ctx.save(); ctx.strokeStyle = 'rgba(0,0,0,0.08)'; ctx.lineWidth = 1; ctx.beginPath(); if (ctx.roundRect) ctx.roundRect(m, m, cw, cw, r); else ctx.rect(m, m, cw, cw); ctx.stroke(); ctx.restore(); }
    canvas._kcaDrawn = true;
    if (!t) return { empty: true };
    var box = cw * 0.84, sc = Math.min(box / t.w, box / t.h), w = t.w * sc, h = t.h * sc;
    var dc = document.createElement('canvas'); dc.width = Math.round(w * 2); dc.height = Math.round(h * 2);
    var d = renderDesign(dc, opts.tpl, Object.assign({}, opts.data, { garment: hex }));
    ctx.drawImage(dc, (S - w) / 2, (S - h) / 2, w, h);
    return { design: d, flat: true };
  }

  function quality(d) { // zwraca liste ostrzezen o zbyt malej rozdzielczosci
    return (d && d._q || []).map(function (q, i) {
      var v = pxPerCm(q.ph, q.wCm, q.hCm); return { i: i, pxcm: v, low: v != null && v < 35 };
    });
  }

  global.KCApparel = {
    TEMPLATES: T, COLORS: COLORS, AREAS: AREAS, DPI: DPI,
    colorHex: colorHex, isDark: isDark, ensureFonts: ensureFonts,
    renderDesign: renderDesign, renderPrint: renderPrint, renderMock: renderMock, renderFlat: renderFlat, dims: dims, designSize: designSize,
    paperToAlpha: paperToAlpha, quality: quality,
    setGreenscreenBase: function (u) { GS_BASE = u; }, setTextureBase: function (u) { TEX_BASE = u; },
    setGarmentImages: function (map) { Object.keys(map).forEach(function (k) { GARMENT_IMG[k] = map[k]; }); },
    // mockupy B: manifest (obiekt mockupy.json) + bazowy URL folderu (np. CDN). fn = przerysuj po doczytaniu zdjecia.
    setMockups: function (manifest, baseUrl, fn) { MOCK = manifest; MOCK_BASE = baseUrl || ''; if (fn) onImg = fn; },
    onImage: function (fn) { onImg = fn; },
    preload: function (type, color) {
      ['front', 'back'].forEach(function (s) { var v = mockView(type, s); if (!v) return; var f = mockFile(v, color); if (f) img(MOCK_BASE + f); img(MOCK_BASE + v.shade); });
    }
  };
})(typeof window !== 'undefined' ? window : this);
